// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-02T22:31:17.782Z
// Property: Daymark Uptown (ID: 6737460151189743)
// Collections: 50 amenities, 55 floorplans (live), 37 photos, 74 POIs, 5 reviews, 23 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6737460151189743",
  "property_external_id": "745560",
  "property_zillow_url": "https://www.zillow.com/apartments/minneapolis-mn/daymark-uptown/CgJFy9/",
  "property_apartments_url": "https://www.apartments.com/daymark-uptown-minneapolis-mn/xpy2mtp",
  "property_google_business_url": "https://www.google.com/maps/place/Daymark+Uptown+Apartment+Homes/@44.9482205,-93.3006961,15z/data=!4m2!3m1!1s0x0:0x636b3bf954dead5c?sa=X&ved=2ahUKEwjau57ThfTtAhWGVN8KHSRoCegQ_BIwEnoECCIQBQ",
  "property_linkedin_url": null,
  "property_hubspot_id": "3120498942",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "daymark-uptown",
  "property_name": "Daymark Uptown",
  "property_website_url": "https://www.daymarkuptown.com/",
  "property_domain": "https://www.daymarkuptown.com/",
  "property_address": "1477 West Lake St.",
  "property_full_address": "1477 W Lake St, Minneapolis, MN 55408",
  "property_address_1": "1477 W Lake St",
  "property_address_2": null,
  "property_address_city": "Minneapolis",
  "property_address_state": "MN",
  "property_address_zip_full": "55408",
  "property_address_zip": "55408",
  "property_address_country": "US",
  "property_address_county": "Hennepin County",
  "property_neighborhood_address": "Calhoun Isles",
  "property_address_latitude": "44.9481501",
  "property_address_longitude": "-93.30055019999999",
  "property_email": "daymark@weidner.com",
  "property_phone": "(651) 240-2142",
  "property_call_tracking_phone": "651-240-2142",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p>Offering brand new urban studios, traditional studios, one and two-bedroom apartments, one and two-bedroom townhomes, and penthouse apartments with modern architecture and designer finishes, Daymark Uptown puts you at the epicenter of vibrant uptown living.</p>",
  "property_long_description": "<p>At Daymark Uptown, you can choose from a variety of floor plans including urban studios, traditional studios, one and two-bedroom apartments, one and two-bedroom townhomes, and penthouse apartments to find the one that perfectly fits your lifestyle. You’ll love your apartment’s large windows that offer breathtaking views of the city and invite in plenty of natural light. You’ll feel inspired in your gourmet kitchen featuring elegant quartz countertops, custom cabinetry, real tile backsplashes, top-of-the-line appliances, under-mount sinks and more because it’s perfect for entertaining. Thoughtfully-designed living areas, garden bathtubs, large walk-in closets and modern conveniences, like having a full-size washer and dryer right in your own home, and being wired for data, audio and video combine to create a luxurious, relaxing place to call home. Also be sure to ask about our select units that feature kitchen islands, private balconies, gas ranges and stylish fireplaces. In addition to the exquisite apartment features, you’ll love our outstanding community amenities.</p><p>You’ll have exclusive access to our inviting rooftop terrace with a full catering kitchen, gas grilling stations, a cozy outdoor fireplace and a shimmering resort-style pool. Enjoy our fully-equipped resident clubhouse with conversational seating and a big-screen TV where you can cheer on your favorite teams along with your neighbors. Enjoy our convenient 24-hour fitness center complete with cardio machines, free weights, and workout equipment. Spend time in our beautiful courtyard where you can glide on our wintertime ice rink and lounge outdoors with friends and family. You will have reserved lot parking onsite with the option of securing a spot in our heated garage to provide extra protection for your vehicle. We also offer underground bike storage with a bike-repair station. Daymark Uptown is a pet-friendly apartment community and we welcome them with a luxe pet park, convenient pet stations, and the understanding that your pets are your beloved furry family members. While Daymark boasts innovative and modern technology throughout, our community also offers plenty of ways to connect with nature, build relationships, and lead an active and productive lifestyle. This upscale apartment community is designed to give you the peace and privacy you’re looking for, while also providing opportunities to network, make friends, and have fun.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-2873-70f3-b12e-1a30ce2b1a49.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with stainless steel appliances and stacked washer/dryer.",
    "public_id": "01a178ef-2873-70f3-b12e-1a30ce2b1a49",
    "storage_key": "property/6737460151189743/01a178ef-2873-70f3-b12e-1a30ce2b1a49.webp",
    "width": 1920,
    "height": 1281
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "328",
  "property_year_built": "2020",
  "property_year_renovated": null,
  "property_walk_score": "97",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.07317073170732",
  "property_admin_fee": "175",
  "property_application_fee": "50",
  "property_fees_deposit_info": "Application Fee: $25\nOther: $100",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "Varies",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": "One-Time Pet Fee: $300 (up to 2 pets)\nPet Deposit: $300 (up to 2 pets)\nMonthly Pet Rent: $50\nAllowed Pets: Cats & Dogs\nPet Limit: 2\nWeight Limit: N/A",
  "property_online_leasing_url": "https://daymarkuptown.securecafe.com/onlineleasing/daymark-uptown/floorplans.aspx",
  "property_resident_portal_url": "https://daymarkuptown.securecafe.com/residentservices/daymark-uptown/userlogin.aspx",
  "property_apply_now_url": "https://daymarkuptown.securecafe.com/onlineleasing/daymark-uptown/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f1e-1ccf-73a8-8cc6-0b930509284a.webp",
  "property_primary_logo_media": {
    "alt_text": "Daymark Uptown Apartments logo",
    "public_id": "01a03f1e-1ccf-73a8-8cc6-0b930509284a",
    "storage_key": "property/6737460151189743/01a03f1e-1ccf-73a8-8cc6-0b930509284a.webp",
    "width": 230,
    "height": 83
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a8-d099-715c-bc6a-d7c70e9ad0ad.webp",
  "property_secondary_logo_media": {
    "alt_text": "Weidner Apartment Homes logo with gray building icons and navy blue text.",
    "public_id": "019d01a8-d099-715c-bc6a-d7c70e9ad0ad",
    "storage_key": "property/6737460151189743/019d01a8-d099-715c-bc6a-d7c70e9ad0ad.webp",
    "width": 325,
    "height": 97
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f1e-5878-7138-aef6-044f047935c3.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a03f1e-5878-7138-aef6-044f047935c3",
    "storage_key": "property/6737460151189743/01a03f1e-5878-7138-aef6-044f047935c3.webp",
    "width": 230,
    "height": 83
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f1e-4cde-7038-a587-60a4ea431007.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a03f1e-4cde-7038-a587-60a4ea431007",
    "storage_key": "property/6737460151189743/01a03f1e-4cde-7038-a587-60a4ea431007.webp",
    "width": 230,
    "height": 83
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#b01b20",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1874",
  "property_sqft_min": "372",
  "property_sqft_max": "1874",
  "property_price_range": "1085 - 7135",
  "property_price_min": "1080",
  "property_price_max": "5595",
  "property_available_units": 26,
  "property_facebook_url": "https://www.facebook.com/Daymark-Uptown-Apartment-Homes-105713654357810",
  "property_instagram_url": "https://www.instagram.com/daymarkuptown/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJCXDf6JUn9ocRXK3eVPk7a2M",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Daymark Uptown",
  "property_home_romance_title": "Pairing flexibility with style, luxurious downtown views, and the best in modern living",
  "property_home_amenities_blurb": "<p>You’ll have exclusive access to our inviting rooftop terrace with a full catering kitchen, gas grilling stations, a cozy outdoor fireplace and a shimmering resort-style pool. Enjoy our fully-equipped resident clubhouse with conversational seating and a big-screen TV where you can cheer on your favorite teams along with your neighbors. Enjoy our convenient 24-hour fitness center complete with cardio machines, free weights, and workout equipment. Spend time in our beautiful courtyard where you can glide on our wintertime ice rink and lounge outdoors with friends and family. You will have reserved lot parking onsite with the option of securing a spot in our heated garage to provide extra protection for your vehicle. We also offer underground bike storage with a bike-repair station. Daymark Uptown is a pet-friendly apartment community and we welcome them with a luxe pet park, convenient pet stations, and the understanding that your pets are your beloved furry family members. While Daymark boasts innovative and modern technology throughout, our community also offers plenty of ways to connect with nature, build relationships, and lead an active and productive lifestyle. This upscale apartment community is designed to give you the peace and privacy you’re looking for, while also providing opportunities to network, make friends, and have fun.</p>",
  "property_home_floorplans_blurb": "<p><strong>Choose a layout with room for the day ahead.</strong> Daymark Uptown offers studio, one-, and two-bedroom apartments, plus townhome-style options with extra space. Select homes feature oversized windows, quartz countertops, stainless steel appliances, full-size washers and dryers, walk-in closets, balconies, and lake or city views—making it easy to compare the details that matter most.</p>",
  "property_home_gallery_blurb": "<p>Daymark is ideally located in the heart of Uptown in one of the most walkable communities in Minneapolis. In fact, you’ll live within walking distance of your favorite parks, restaurants, grocery stores, the Chain of Lakes, and we have dedicated retail space on the first floor of our building. It’s an excellent choice for busy professionals who commute to Downtown. In addition, you can quickly jump on nearby I-35, I-94, and Hwy 100 to get to work or school, including The University of Minnesota just 15 minutes away. This community is perfect for foodies who want to be close to a variety of different restaurants such as Amazing Thai and Agra Culture Kitchen. Right across the lake is a popular dog park, and you’ll live just a short drive from Target, The Galleria, and The Mall of America for your shopping needs. You’ll also be surrounded by many local parks such as Lake of the Isles Park and Kenwood Park, both popular options for water sports and outdoor recreational activities.</p>",
  "property_home_neighborhood_blurb": "<p>Daymark is ideally located in the heart of Uptown in one of the most walkable communities in Minneapolis. In fact, you’ll live within walking distance of your favorite parks, restaurants, grocery stores, the Chain of Lakes, and we have dedicated retail space on the first floor of our building. It’s an excellent choice for busy professionals who commute to Downtown. In addition, you can quickly jump on nearby I-35, I-94, and Hwy 100 to get to work or school, including The University of Minnesota just 15 minutes away. This community is perfect for foodies who want to be close to a variety of different restaurants such as Amazing Thai and Agra Culture Kitchen. Right across the lake is a popular dog park, and you’ll live just a short drive from Target, The Galleria, and The Mall of America for your shopping needs. You’ll also be surrounded by many local parks such as Lake of the Isles Park and Kenwood Park, both popular options for water sports and outdoor recreational activities.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents love the care behind the everyday.</strong><br>Reviews for Daymark Uptown call out a responsive, welcoming team that remembers names, listens closely, and keeps things running smoothly. Spotless spaces, valuable amenities, and resident events—from movie nights to standout outings—also earn frequent praise. Read the reviews to see why the “community feel is truly one of a kind.”</p>",
  "property_neighborhood_blurb": "<p>Daymark is ideally located in the heart of Uptown in one of the most walkable communities in Minneapolis. In fact, you’ll live within walking distance of your favorite parks, restaurants, grocery stores, the Chain of Lakes, and we have dedicated retail space on the first floor of our building. It’s an excellent choice for busy professionals who commute to Downtown. In addition, you can quickly jump on nearby I-35, I-94, and Hwy 100 to get to work or school, including The University of Minnesota just 15 minutes away. This community is perfect for foodies who want to be close to a variety of different restaurants such as Amazing Thai and Agra Culture Kitchen. Right across the lake is a popular dog park, and you’ll live just a short drive from Target, The Galleria, and The Mall of America for your shopping needs. You’ll also be surrounded by many local parks such as Lake of the Isles Park and Kenwood Park, both popular options for water sports and outdoor recreational activities.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-rich living, designed around your whole day.</strong> At Daymark Uptown, start with a skyline workout in the top-floor fitness and yoga studio, unwind by the sparkling pool and spa, then move the evening to the indoor/outdoor rooftop fireside lounge or a reservable club room with a catering kitchen. Practical comforts are just as considered, from controlled access and after-hours concierge service to elevators, dry cleaning, bike storage with repair station, charging stations, and a heated underground garage.</p><p>Inside your home, elevated finishes keep the look clean and the routine easy: 9-10’ ceilings, oversized windows, quartz countertops, custom cabinetry, stainless steel appliances, full-size laundry, walk-in closets, and select balconies, fireplaces, gas ranges, or lake and city views. Browse the <a href=\"/gallery\">photo gallery</a>, review details for the on-site <a href=\"/pet-policy\">pet park</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the spaces in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Daymark Uptown home?</strong> Choose from modern studios, one- and two-bedroom apartments, townhome-style layouts, and penthouse options with standout finishes and access to inviting community spaces. Review <a href=\"/floor-plans\">available floor plans</a>, find your fit in Calhoun Isles, and start your application online today.</p>",
  "property_contactus_blurb": "<p>Fill out the form below, drop us a line, or stop by to learn how you can start living in luxury at Daymark Uptown.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Daymark Uptown?</strong> Start here for quick answers on the community, leasing, amenities, and daily living at our Uptown Minneapolis apartments. If you don’t see what you need, the leasing team is happy to help you find the details and next steps.</p>",
  "property_floorplans_blurb": "<p>Quickly find just the right floor plan for you. If your desired floor plan isn't available, be sure to contact us and we will notify you.</p>",
  "property_gallery_blurb": "<p><strong>Start with the view, then follow the light.</strong> Browse Daymark Uptown’s photo gallery to see sun-filled apartments with oversized windows, warm plank-style flooring, sleek quartz kitchens, and select balconies framing lake or city outlooks. The images move easily from polished interiors to shared spaces made for everyday ease: a resort-style pool and spa with a broad sundeck, rooftop fireside lounges, a courtyard, and a top-floor fitness and yoga studio with downtown Minneapolis skyline views. You’ll also get a closer look at details that make the community feel complete, from lounge seating and catering kitchens to the pet park and heated garage. Like what you see? Explore <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Daymark Uptown on the map.</strong> See available apartments alongside West Lake Street essentials, nearby dining and shopping, and easy access to lakeside paths, bike rides, and skyline views around Calhoun Isles.</p>",
  "property_pets_blurb": "<p>At Daymark Uptown Apartments, we’re not just pet-friendly, we LOVE pets and show it by providing a fenced-in pet exercise area, always having treats in the office and hosting frequent Yappy Hours, an event for dogs and their owners to socialize, take pics in a photo booth, eat snacks and get beautified by the visiting dog groomer.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Daymark Uptown lifestyle.</strong> If you love modern finishes, lake-and-city energy, rooftop spaces, and easy access to Uptown essentials, invite a friend to find their fit here. Send a referral and help them discover apartment living steps from the best of Calhoun Isles.</p>",
  "property_residentaccess_blurb": "<p><strong>Daymark Uptown resident access starts here.</strong><br>Pay rent, submit maintenance requests, and manage account details in one convenient place—so daily needs stay simple at home near West Lake Street, Bde Maka Ska, and the Midtown Greenway.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying about Daymark Uptown.</strong><br>Reviews highlight a team that’s professional, welcoming, and quick to respond, with residents noting how staff members remember names, listen closely, and help make everyday living feel easy. You’ll also read praise for spotless facilities, valuable amenities, and a calendar of resident events that brings people together—from movie nights to memorable outings.</p><p>Many reviews return to the same feeling: Daymark Uptown offers a genuine sense of care. As one resident put it, the “community feel is truly one of a kind.” Browse the reviews below to hear firsthand what makes life here stand out.</p>",
  "property_created_at": "1752256846819",
  "property_scheduletour_blurb": "<p><strong>See Daymark Uptown in person.</strong> Tour modern layouts with oversized windows, quartz countertops, stainless steel appliances, and full-size washers and dryers—then picture the rooftop lounge, pool and spa, fitness studio, and lakefront Minneapolis energy just beyond your door. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out.</strong> Your inquiry has been received, and the Daymark Uptown leasing team will follow up soon. In the meantime, picture modern apartment living where Uptown energy meets lakefront Minneapolis, with stylish finishes, inviting community spaces, and Calhoun Isles conveniences close to home.</p>",
  "property_virtualtours_blurb": "<p><strong>Tour Daymark Uptown from wherever you are.</strong> Move room by room through apartment options like 1 Bedroom Model #630, 2 Bedroom Unit #628, N109 Holmes, the Townhome, and named layouts including Carver, Elmo, Crystal, White Bear, Mille Lacs, Big Sandy, Gull, Minnetonka, and more. As you click through, look for the details that shape everyday living: open kitchens, in-home laundry, oversized windows, clean modern finishes, and layouts that range from streamlined studios to roomier two-bedroom and townhome-style spaces. Then step into the Lobby, Club Room, and Fitness Center tours to preview the community spaces before you arrive in Minneapolis. Compare options on the <a href=\"/floor-plans\">floor plans</a> page, browse the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see it in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Daymark Uptown",
  "property_seo_title_home": "Daymark Uptown |  Apartments in Minneapolis, MN",
  "property_seo_description_home": "Experience urban luxury at Daymark Uptown with skyline views, resort-style amenities, and a vibrant community near downtown Minneapolis!",
  "property_seo_title_floorplans": "Floor Plans | Minneapolis, MN Apartments for Rent",
  "property_seo_description_floorplans": "Elevate your lifestyle at Daymark Uptown in Minneapolis! Choose from stylish studios to spacious two-bedroom apartments. Find your ideal layout today!",
  "property_seo_title_amenities": "Amenities | Minneapolis, MN Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Daymark Uptown! Indulge in luxury amenities, stunning views, and a vibrant community. Your perfect Minneapolis home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Minneapolis, MN",
  "property_seo_description_gallery": "Experience luxury at Daymark Uptown! Enjoy stunning views, resort-style amenities, and a vibrant community just steps from downtown Minneapolis.",
  "property_seo_title_virtualtours": "Virtual Tours | Daymark Uptown Apartments",
  "property_seo_description_virtualtours": "Experience modern living at Daymark Uptown in Minneapolis, MN. Dive into our studio, one, and two-bedroom apartments with a vibrant virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Daymark Uptown Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Daymark Uptown in Minneapolis. Enjoy luxury amenities, a vibrant community, and easy access to nature. Make it yours today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Minneapolis, MN",
  "property_seo_description_neighborhood": "Experience the vibrant Minneapolis lifestyle at Daymark Uptown! Uncover local gems, eateries, and unique attractions just steps from our community.",
  "property_seo_title_contact": "Contact Us | Daymark Uptown",
  "property_seo_description_contact": "Connect with Daymark Uptown in vibrant Minneapolis! From studios to two-bedrooms, we have the perfect floor plan for you. Reach out to our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Minneapolis, MN",
  "property_seo_description_faqs": "Uncover answers about Daymark Uptown in Minneapolis! From luxurious amenities to vibrant living, our FAQs highlight everything you need to know. Explore now!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Minneapolis, MN",
  "property_seo_description_reviews": "Experience life at Daymark Uptown in Minneapolis. See what our residents love about luxurious amenities, prime location, and vibrant community living!",
  "property_seo_title_applynow": "Apply Now | Apartments in Minneapolis, MN",
  "property_seo_description_applynow": "Elevate your lifestyle at Daymark Uptown! Nestled in vibrant Minneapolis, enjoy luxe amenities, stunning views, and a community designed for modern living.",
  "property_seo_title_residentaccess": "Resident Access | Daymark Uptown",
  "property_seo_description_residentaccess": "Log in to Daymark Uptown's resident portal for easy rent payments, maintenance requests, and community updates. Your comfortable living in Minneapolis awaits!",
  "property_seo_title_referafriend": "Refer A Friend | Daymark Uptown",
  "property_seo_description_referafriend": "Great friends make great neighbors at Daymark Uptown! Refer a friend to our vibrant Minneapolis community and enjoy rewards together in style!",
  "property_seo_title_scheduletour": "Schedule a Tour | Daymark Uptown",
  "property_seo_description_scheduletour": "Experience urban living at Daymark Uptown in Minneapolis! Schedule a tour today and step into your future home where comfort meets convenience.",
  "property_seo_title_privacy": "Privacy Policy | Daymark Uptown",
  "property_seo_description_privacy": "At Daymark Uptown, your privacy matters. Explore our commitment to data protection and improved living experiences. Read our policy!",
  "property_seo_title_accessibility": "Website Accessibility | Daymark Uptown",
  "property_seo_description_accessibility": "Experience seamless living at Daymark Uptown, Minneapolis, where digital inclusion ensures accessibility for all. Join our valued community!",
  "property_seo_title_sitemap": "Sitemap | Daymark Uptown",
  "property_seo_description_sitemap": "Uncover the hidden gems of Daymark Uptown! Navigate our sitemap to explore vibrant amenities, floor plans, and the charm of Minneapolis living.",
  "property_seo_title_thankyou": "Thank You | Daymark Uptown",
  "property_seo_description_thankyou": "Thank you for reaching out to Daymark Uptown! We're excited to connect soon and help you discover your perfect Minneapolis home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Minneapolis, MN",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793650743541",
  "amenities": [
    {
      "id": "ec_10560f5136199c267542626d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87682712",
      "title": "Located in Uptown, minutes from downtown, walking distance to the Lakes and The Greenway",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_81fd5536d09f5cd91ebff3eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87426758",
      "title": "On-Site Management and Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4a39b5f8ecd9a66b675c7322",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87426756",
      "title": "After-hours Concierge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_113c62684c4cdc2b1b48141d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87384769",
      "title": "Controlled Access Buildings",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ded5dd537f52a00656b67c92",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87384758",
      "title": "Underground heated garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_47f2debcfffc182d23546ff4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87414619",
      "title": "Elevators",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c845fe0e192532b5147a8240",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87682716",
      "title": "Reservable Club House with catering kitchen, big screen TV and lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a19e0b-7da9-74bd-a93d-c803cd8c6eb0.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen island with stainless steel sink and faucet, overlooking a communal living area with seating and art.",
        "public_id": "01a19e0b-7da9-74bd-a93d-c803cd8c6eb0",
        "storage_key": "property/6737460151189743/01a19e0b-7da9-74bd-a93d-c803cd8c6eb0.webp",
        "width": 1200,
        "height": 675
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56f028244497562282d80370",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87682715",
      "title": "Sparkling pool and spa with resort style sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a19e0b-7de9-74dc-8d07-10d29bb1fc82.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and umbrellas.",
        "public_id": "01a19e0b-7de9-74dc-8d07-10d29bb1fc82",
        "storage_key": "property/6737460151189743/01a19e0b-7de9-74dc-8d07-10d29bb1fc82.webp",
        "width": 1200,
        "height": 675
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b07620eb156d2c87ba698667",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87768964",
      "title": "9-10’ ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cdeef9c790b8755b19b745fe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87682708",
      "title": "Over-sized windows with window treatments",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3d245d999dc837fdf805f9ac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87682705",
      "title": "Quartz countertops with under-mount sinks and custom cabinets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a19e0b-7eb9-71f6-b1d1-a449aa197a52.webp",
      "amenity_image_media": {
        "alt_text": "Modern apartment kitchen with stainless steel appliances and a large island.",
        "public_id": "01a19e0b-7eb9-71f6-b1d1-a449aa197a52",
        "storage_key": "property/6737460151189743/01a19e0b-7eb9-71f6-b1d1-a449aa197a52.webp",
        "width": 1025,
        "height": 684
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2962db73dc1ccd923e509dc5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87682702",
      "title": "Lake or City views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8121f42d4ccaf02d8326e1e8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87426752",
      "title": "Full Size Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_629f6ad48fe970a0f58ed89c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87414618",
      "title": "Patio/Balcony in Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0c7d3bd6ef1b83616b86d217",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87414617",
      "title": "Luxury hardwood plank style flooring in kitchen and living areas",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a19e0b-7d91-7118-b409-3e2e3761943b.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen and dining area with stainless steel appliances, island with bar stools, and a round dining table.",
        "public_id": "01a19e0b-7d91-7118-b409-3e2e3761943b",
        "storage_key": "property/6737460151189743/01a19e0b-7d91-7118-b409-3e2e3761943b.webp",
        "width": 1023,
        "height": 682
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c02a4efed5f2bb73e59fbbe8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87682632",
      "title": "Carpeted bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a19e0b-7d9c-7342-b49c-4d6180639cbd.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a walk-in closet and ensuite bathroom access.",
        "public_id": "01a19e0b-7d9c-7342-b49c-4d6180639cbd",
        "storage_key": "property/6737460151189743/01a19e0b-7d9c-7342-b49c-4d6180639cbd.webp",
        "width": 1025,
        "height": 684
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a9b6ee6b723bf1bc18e2ccf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87682701",
      "title": "Stainless Steel Refrigerator, built-in Microwave, Oven and Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a19e0b-8968-727e-abda-549a3d82616b.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with double ovens, stainless steel appliances, and an island.",
        "public_id": "01a19e0b-8968-727e-abda-549a3d82616b",
        "storage_key": "property/6737460151189743/01a19e0b-8968-727e-abda-549a3d82616b.webp",
        "width": 1025,
        "height": 684
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dbdcbe2a96a613457f8ad898",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87682704",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_edb2b946fc58a0031f7715b7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87682713",
      "title": "Indoor and outdoor Rooftop Fireside Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a19e0b-898e-70fd-af34-8c831abca374.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor seating area with a large fireplace and lounge chairs.",
        "public_id": "01a19e0b-898e-70fd-af34-8c831abca374",
        "storage_key": "property/6737460151189743/01a19e0b-898e-70fd-af34-8c831abca374.webp",
        "width": 1200,
        "height": 675
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_84d097589cb950bcd5ce952d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87682719",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a19e0b-89be-75c9-b403-20bfaa1b4b91.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor communal gathering space with a large brick fire pit, seating, and string lights overhead.",
        "public_id": "01a19e0b-89be-75c9-b403-20bfaa1b4b91",
        "storage_key": "property/6737460151189743/01a19e0b-89be-75c9-b403-20bfaa1b4b91.webp",
        "width": 1200,
        "height": 675
      },
      "amenity_image_alt_text": "Daymark Courtyard Fire Pit",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_01e50f40b0a9ff0fd8e2b03e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87682714",
      "title": "Reservable Top floor community room with catering kitchen",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a19e0b-8ae1-740e-875d-93c4e3ac2bfc.webp",
      "amenity_image_media": {
        "alt_text": "Modern communal lounge area with a kitchen island and seating.",
        "public_id": "01a19e0b-8ae1-740e-875d-93c4e3ac2bfc",
        "storage_key": "property/6737460151189743/01a19e0b-8ae1-740e-875d-93c4e3ac2bfc.webp",
        "width": 1200,
        "height": 675
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_deb9dbe61f13fd4b946a1cbd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87682717",
      "title": "24-top Top Floor Low Impact Fitness Center and Yoga Studio with Skyline Views of Downtown Minneapolis",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a19e0b-8ef2-75e0-9180-dc534528d321.webp",
      "amenity_image_media": {
        "alt_text": "Gym with weight machines and treadmills",
        "public_id": "01a19e0b-8ef2-75e0-9180-dc534528d321",
        "storage_key": "property/6737460151189743/01a19e0b-8ef2-75e0-9180-dc534528d321.webp",
        "width": 1200,
        "height": 675
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_98e7d85dbacc2184f2f54cbd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87682706",
      "title": "Porcelain tile bathroom floors*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ef8b7a803c6404e9c718b6a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87682707",
      "title": "Garden soaking tubs",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a19e0b-92d2-75c7-8738-9f0e520786b2.webp",
      "amenity_image_media": {
        "alt_text": "Modern bathroom with double vanity, soaking tub, and subway tile shower.",
        "public_id": "01a19e0b-92d2-75c7-8738-9f0e520786b2",
        "storage_key": "property/6737460151189743/01a19e0b-92d2-75c7-8738-9f0e520786b2.webp",
        "width": 1025,
        "height": 684
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e0bebaf4ba64f19fd973078",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87682718",
      "title": "Resident grilling stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a19e0b-94ca-70fa-b3f0-2329a12b3c78.webp",
      "amenity_image_media": {
        "alt_text": "Rooftop lounge area with modern red sofas and chairs surrounding a concrete fire pit.",
        "public_id": "01a19e0b-94ca-70fa-b3f0-2329a12b3c78",
        "storage_key": "property/6737460151189743/01a19e0b-94ca-70fa-b3f0-2329a12b3c78.webp",
        "width": 1176,
        "height": 661
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_875cdbd505b9f67433a96137",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87768959",
      "title": "Planned social activities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d5e545cf73ddbcaa19c27a01",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87682709",
      "title": "Walk in Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a19e0b-958e-71f8-97f6-a9ac3bbbb9ad.webp",
      "amenity_image_media": {
        "alt_text": "Closet with shelves and view into a bathroom with tub and toilet",
        "public_id": "01a19e0b-958e-71f8-97f6-a9ac3bbbb9ad",
        "storage_key": "property/6737460151189743/01a19e0b-958e-71f8-97f6-a9ac3bbbb9ad.webp",
        "width": 1200,
        "height": 675
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_609b7f2d32bdab660b4d1541",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87768984",
      "title": "Dry-cleaning",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72429ca5d7a1aecd7a44a320",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87682710",
      "title": "Wired for Data/Audio/Video",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bd287c545f3089f068c5d778",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87782805",
      "title": "On-site resident Pet Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a7e8f3c1bb885c51d7d4b98",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87764538",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f59efc78a962aa7c8bf99f29",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87782807",
      "title": "Bike Storage Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b8dc846e8252f8e61866637",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "126759282",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db5f84f6d9cec813951ce140",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "87782812",
      "title": "Electric Vehicle Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c90e488f17a184dd59315942",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "126759312",
      "title": "Oversized Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8cbde323230f331d51cf5074",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "126759316",
      "title": "Basement",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ebd5eb2d654f0a7a3917475d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "126759327",
      "title": "1st Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad9dadb5882e122b40c32b88",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "126759338",
      "title": "2nd Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_27e3950a8203e696d05a0435",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "126759341",
      "title": "3rd Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_758198b1cf83f6a39b6d7e5c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "126759343",
      "title": "4th Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7e8027b436d9519865468e7c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "126759345",
      "title": "5th Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_06cf680a5717bf85eba4e0ea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "126759348",
      "title": "6th Floor - 10ft. Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb459f4ed07bf763b2783dbd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "126759350",
      "title": "Loft",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04a63e53cc9f24a6e2fe0e60",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "126759354",
      "title": "Modern Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bfb320af4a856c80932c20c8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "126759360",
      "title": "North Facing",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_18a93005817ac2847bf64b75",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "126759369",
      "title": "Lake View",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7a3b0aeba60521aa800a12dd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "126759378",
      "title": "Skyline View",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_332a9949a965851a400dceba",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "126759384",
      "title": "Vintage Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bdb666f275fdd3a258fddc3c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "126759401",
      "title": "Pool View",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_060bf60372d9cd66766e7ad2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "126759404",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_85f68cdaa692ba12f3a543aa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-2873-70f3-b12e-1a30ce2b1a49.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and stacked washer/dryer.",
        "public_id": "01a178ef-2873-70f3-b12e-1a30ce2b1a49",
        "storage_key": "property/6737460151189743/01a178ef-2873-70f3-b12e-1a30ce2b1a49.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Sleek and modern kitchen featuring stainless steel appliances, a gas range, and a convenient in-unit washer and dryer.",
      "link": "false",
      "alt_text": "A modern kitchen with a marble countertop and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(43).jpg"
    },
    {
      "id": "ec_eab84d66a9a72010f46c9c99",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-07a8-72e1-9898-f0559b4ac0d7.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, island with bar stools, and dining area with blue chairs.",
        "public_id": "01a178ef-07a8-72e1-9898-f0559b4ac0d7",
        "storage_key": "property/6737460151189743/01a178ef-07a8-72e1-9898-f0559b4ac0d7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience luxurious living in this spacious apartment featuring a gourmet kitchen with stainless steel appliances, a breakfast bar, and an elegant dining area perfect for entertaining.",
      "link": "false",
      "alt_text": "A modern kitchen with a dining table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(71).jpg"
    },
    {
      "id": "ec_ed193f35bc302deda40f3ae6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-34b5-763b-81c9-ca86061ff68e.webp",
      "image_media": {
        "alt_text": "Modern open-concept living room and kitchen with large windows and a fireplace.",
        "public_id": "01a178ef-34b5-763b-81c9-ca86061ff68e",
        "storage_key": "property/6737460151189743/01a178ef-34b5-763b-81c9-ca86061ff68e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area seamlessly flows into a modern kitchen, perfect for entertaining. Features high ceilings, large windows, and premium appliances.",
      "link": "false",
      "alt_text": "A modern kitchen with a long white island and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(61).jpg"
    },
    {
      "id": "ec_09af2b69f4e6216677350e05",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-3b10-7659-96d5-39d9e6592f00.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and dark wood cabinetry.",
        "public_id": "01a178ef-3b10-7659-96d5-39d9e6592f00",
        "storage_key": "property/6737460151189743/01a178ef-3b10-7659-96d5-39d9e6592f00.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Chic and functional kitchen featuring stainless steel appliances, a subway tile backsplash, and ample dark wood cabinetry for storage.",
      "link": "false",
      "alt_text": "A modern kitchen with a stainless steel refrigerator, microwave, oven, and dishwasher.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(47).jpg"
    },
    {
      "id": "ec_e29b2c751cc8c2ffdf038cf7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-286d-77e9-8261-2ffc099840fa.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island.",
        "public_id": "01a178ef-286d-77e9-8261-2ffc099840fa",
        "storage_key": "property/6737460151189743/01a178ef-286d-77e9-8261-2ffc099840fa.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Experience culinary convenience in this beautifully appointed kitchen, featuring sleek stainless steel appliances, ample cabinetry, and a spacious island perfect for meal prep and entertaining.",
      "link": "false",
      "alt_text": "A modern kitchen with stainless steel appliances and white cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(44).jpg"
    },
    {
      "id": "ec_5a16cf6cca888a0325d6036f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-37e4-7500-84e6-0ae3d31e108e.webp",
      "image_media": {
        "alt_text": "Stylish living room with large windows and modern furniture.",
        "public_id": "01a178ef-37e4-7500-84e6-0ae3d31e108e",
        "storage_key": "property/6737460151189743/01a178ef-37e4-7500-84e6-0ae3d31e108e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Enjoy spacious living in this beautifully appointed apartment, featuring a modern design with ample natural light and comfortable seating.",
      "link": "false",
      "alt_text": "A modern living room with a glass table and a white sofa.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(42).jpg"
    },
    {
      "id": "ec_d948f741762227effb7cf869",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-98c4-7442-a355-176104edd26f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and wood-grain cabinetry.",
        "public_id": "01a178ef-98c4-7442-a355-176104edd26f",
        "storage_key": "property/6737460151189743/01a178ef-98c4-7442-a355-176104edd26f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this sleek, modern kitchen featuring stainless steel appliances, ample cabinet space with a wood-grain finish, and a subway tile backsplash.",
      "link": "false",
      "alt_text": "A modern kitchen with a stainless steel refrigerator and wooden cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(70).jpg"
    },
    {
      "id": "ec_7e7e159e1589b611d55142c9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-6d12-73df-aac6-bb63fa823e4e.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, abstract art, and a nightstand.",
        "public_id": "01a178ef-6d12-73df-aac6-bb63fa823e4e",
        "storage_key": "property/6737460151189743/01a178ef-6d12-73df-aac6-bb63fa823e4e.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a plush queen-sized bed, modern abstract artwork, and convenient nightstands on either side. Perfect for relaxation and comfort.",
      "link": "false",
      "alt_text": "A bedroom with a bed, two lamps, and two paintings on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(69).jpg"
    },
    {
      "id": "ec_753111eed6940d419d78aed1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-64b8-7637-b290-fd3bf07831fd.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, modern art, and a bedside table.",
        "public_id": "01a178ef-64b8-7637-b290-fd3bf07831fd",
        "storage_key": "property/6737460151189743/01a178ef-64b8-7637-b290-fd3bf07831fd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a queen-size bed, contemporary artwork, and elegant decor. Your private sanctuary awaits.",
      "link": "false",
      "alt_text": "A bedroom with a large bed and a painting on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(68).jpg"
    },
    {
      "id": "ec_e3c4fae3072cda2da3ff9767",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-5735-733d-9b66-de9e389da726.webp",
      "image_media": {
        "alt_text": "Modern bedroom with abstract art and a queen-sized bed.",
        "public_id": "01a178ef-5735-733d-9b66-de9e389da726",
        "storage_key": "property/6737460151189743/01a178ef-5735-733d-9b66-de9e389da726.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully appointed bedroom, featuring vibrant abstract art and a plush queen-sized bed. Perfect for relaxation and unwinding.",
      "link": "false",
      "alt_text": "A bedroom with a bed, a nightstand, and three paintings on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(66).jpg"
    },
    {
      "id": "ec_5e3d20ef857060922214572a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-557a-72c3-ae57-02d899bd8ef7.webp",
      "image_media": {
        "alt_text": "Modern bedroom with abstract art and a comfortable bed.",
        "public_id": "01a178ef-557a-72c3-ae57-02d899bd8ef7",
        "storage_key": "property/6737460151189743/01a178ef-557a-72c3-ae57-02d899bd8ef7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring contemporary decor and plush bedding.",
      "link": "false",
      "alt_text": "A bedroom with a bed, a table, and a painting on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(65).jpg"
    },
    {
      "id": "ec_c008726a697c0a792eb669c2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-4efc-72c9-97ff-3656ec719a2c.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, walk-in closet, and an ensuite bathroom visible.",
        "public_id": "01a178ef-4efc-72c9-97ff-3656ec719a2c",
        "storage_key": "property/6737460151189743/01a178ef-4efc-72c9-97ff-3656ec719a2c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, ample closet space, and a stylish design. Enjoy a private ensuite bathroom for ultimate convenience.",
      "link": "false",
      "alt_text": "A bedroom with a large bed and a painting above it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(63).jpg"
    },
    {
      "id": "ec_30e3a7b1d1ba8a192d00ce89",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-6fdd-747c-a7c7-cfa89535c860.webp",
      "image_media": {
        "alt_text": "A master bedroom with a king-size bed, mirrored vanity, and walk-in closet.",
        "public_id": "01a178ef-6fdd-747c-a7c7-cfa89535c860",
        "storage_key": "property/6737460151189743/01a178ef-6fdd-747c-a7c7-cfa89535c860.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in your spacious master bedroom, complete with a comfortable king-size bed, elegant mirrored vanity, and a convenient walk-in closet.",
      "link": "false",
      "alt_text": "A bedroom with a bed, a mirror, and a painting on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(59).jpg"
    },
    {
      "id": "ec_1e7bcd216426701b4317ed01",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-8ddd-7745-9554-45bbfe8a2294.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, vessel sink, subway tile shower, and a bathtub.",
        "public_id": "01a178ef-8ddd-7745-9554-45bbfe8a2294",
        "storage_key": "property/6737460151189743/01a178ef-8ddd-7745-9554-45bbfe8a2294.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience the perfect blend of style and comfort in this beautifully appointed apartment bathroom, featuring a sleek vanity, vessel sink, and elegant subway tile shower and tub.",
      "link": "false",
      "alt_text": "A bathroom with a white sink and a white bathtub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(57).jpg"
    },
    {
      "id": "ec_f161c0c78882fb8427836e15",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-878f-70b5-b065-2b146a60ee79.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with dual vessel sinks, chrome faucets, and a large mirror.",
        "public_id": "01a178ef-878f-70b5-b065-2b146a60ee79",
        "storage_key": "property/6737460151189743/01a178ef-878f-70b5-b065-2b146a60ee79.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience luxury in this spacious bathroom, featuring a double vanity with vessel sinks, ample counter space, and elegant fixtures.",
      "link": "false",
      "alt_text": "A white bathroom with a white sink and a white framed picture on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(56).jpg"
    },
    {
      "id": "ec_749fc6e5a24a8de66ccac425",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-85e7-72e6-b351-47be4f57ff7c.webp",
      "image_media": {
        "alt_text": "Empty apartment bedroom with large window and door to hallway.",
        "public_id": "01a178ef-85e7-72e6-b351-47be4f57ff7c",
        "storage_key": "property/6737460151189743/01a178ef-85e7-72e6-b351-47be4f57ff7c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious apartment bedroom, ready for your personal touch. Features a large window with city views and plush carpeting.",
      "link": "false",
      "alt_text": "A room with a large window overlooking a building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(54).jpg"
    },
    {
      "id": "ec_d8ba3bad0153cfd6d895d1db",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a19e0b-bb9b-771f-82fd-351f37cfb5b4.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, white subway tile shower, and large mirror.",
        "public_id": "01a19e0b-bb9b-771f-82fd-351f37cfb5b4",
        "storage_key": "property/6737460151189743/01a19e0b-bb9b-771f-82fd-351f37cfb5b4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a spacious double vanity with sleek vessel sinks, complemented by white subway tile accents in the shower and a large, illuminated mirror. Perfect for a relaxing retreat.",
      "link": "false",
      "alt_text": "A bathroom with a white tub, sink, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(53).jpg"
    },
    {
      "id": "ec_4ea34b2f205c4f3a488a0f8d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a19e0b-bc43-747a-a8c1-46af9bcf2c6b.webp",
      "image_media": {
        "alt_text": "View of a bedroom with closet and ensuite bathroom. Open doors reveal a walk-in closet and a tiled shower.",
        "public_id": "01a19e0b-bc43-747a-a8c1-46af9bcf2c6b",
        "storage_key": "property/6737460151189743/01a19e0b-bc43-747a-a8c1-46af9bcf2c6b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this spacious bedroom, featuring a large walk-in closet and an ensuite bathroom with a sleek tiled shower. Perfect for comfort and convenience.",
      "link": "false",
      "alt_text": "A room with three open doors leading to other rooms.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(51).jpg"
    },
    {
      "id": "ec_469c3c0eae05c18f64c129c5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-48d1-758d-96c6-ecd2c5c12af5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, stainless steel appliances, and pendant lights.",
        "public_id": "01a178ef-48d1-758d-96c6-ecd2c5c12af5",
        "storage_key": "property/6737460151189743/01a178ef-48d1-758d-96c6-ecd2c5c12af5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring a large island, sleek cabinetry, stainless steel appliances, and decorative pendant lighting. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "A modern kitchen with a large island and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(50).jpg"
    },
    {
      "id": "ec_a3d851b64527e8a9e3a2e144",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-2a77-7781-a470-9a4a51e34026.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with a gray sofa, coffee table, and dining set.",
        "public_id": "01a178ef-2a77-7781-a470-9a4a51e34026",
        "storage_key": "property/6737460151189743/01a178ef-2a77-7781-a470-9a4a51e34026.webp",
        "width": 3000,
        "height": 2250
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment featuring an open-concept living and kitchen area. Perfect for entertaining and comfortable living.",
      "link": "false",
      "alt_text": "A modern living room with a grey sofa and a glass coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(48).jpg"
    },
    {
      "id": "ec_0b910bdd4c14333807db10b0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-3a60-70aa-91cb-19206f830e77.webp",
      "image_media": {
        "alt_text": "Living room with blue sofa, armchair, coffee table, and bar cart.",
        "public_id": "01a178ef-3a60-70aa-91cb-19206f830e77",
        "storage_key": "property/6737460151189743/01a178ef-3a60-70aa-91cb-19206f830e77.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable blue sofa, a stylish armchair, a modern coffee table, and a convenient bar cart, perfect for entertaining.",
      "link": "false",
      "alt_text": "A living room with a blue sofa and a painting on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(45).JPG"
    },
    {
      "id": "ec_8de2088d14eaf1f2745b0e34",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-7290-76e2-89d1-4c19ff0efe10.webp",
      "image_media": {
        "alt_text": "Empty room with wood-look flooring and a large window with a view of city buildings.",
        "public_id": "01a178ef-7290-76e2-89d1-4c19ff0efe10",
        "storage_key": "property/6737460151189743/01a178ef-7290-76e2-89d1-4c19ff0efe10.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious empty room featuring neutral-toned walls, wood-look flooring, and a large window offering a city view. Ready for your personal touch.",
      "link": "false",
      "alt_text": "A room with a window and a wall-mounted air conditioner.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(38).jpg"
    },
    {
      "id": "ec_8459c464652f81c8c6594197",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-746d-775d-aac2-0124343010f4.webp",
      "image_media": {
        "alt_text": "Interior view of an empty apartment kitchen and living area with a closed closet.",
        "public_id": "01a178ef-746d-775d-aac2-0124343010f4",
        "storage_key": "property/6737460151189743/01a178ef-746d-775d-aac2-0124343010f4.webp",
        "width": 1022,
        "height": 681
      },
      "title": "Apartment",
      "description": "Spacious apartment layout featuring a modern kitchen with stainless steel appliances and ample cabinet space, adjacent to a living area with wood-look flooring. Includes a convenient in-unit closet.",
      "link": "false",
      "alt_text": "A kitchen with a refrigerator, microwave, and oven.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(40).jpg"
    },
    {
      "id": "ec_f67233a0179f06a4ac81f17c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-81ba-713d-825b-4bb8d04d3a62.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with a large wooden framed mirror and a sleek white sink. View of the kitchen through doorway.",
        "public_id": "01a178ef-81ba-713d-825b-4bb8d04d3a62",
        "storage_key": "property/6737460151189743/01a178ef-81ba-713d-825b-4bb8d04d3a62.webp",
        "width": 1023,
        "height": 682
      },
      "title": "Apartment",
      "description": "Experience luxury in this modern apartment bathroom featuring a spacious vanity, elegant mirror, and a well-appointed kitchen visible through an open doorway.",
      "link": "false",
      "alt_text": "A bathroom with a sink, mirror, and a refrigerator in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(39).jpg"
    },
    {
      "id": "ec_be3028a79f89cdf64e648d7c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-9ae6-7276-b933-deb78b804e12.webp",
      "image_media": {
        "alt_text": "Modern lobby with red abstract seating, a reception desk, and large windows overlooking an outdoor patio.",
        "public_id": "01a178ef-9ae6-7276-b933-deb78b804e12",
        "storage_key": "property/6737460151189743/01a178ef-9ae6-7276-b933-deb78b804e12.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Step into the stylish lobby featuring unique red seating and a sleek reception desk, perfect for welcoming guests or relaxing.",
      "link": "false",
      "alt_text": "A modern interior with red chairs and a bar area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(62).jpg"
    },
    {
      "id": "ec_c6d400af0cc96133af838024",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-b57e-7689-84c4-01c17490b0db.webp",
      "image_media": {
        "alt_text": "Modern community lounge with dining tables, a kitchen island, and large windows overlooking the outdoors.",
        "public_id": "01a178ef-b57e-7689-84c4-01c17490b0db",
        "storage_key": "property/6737460151189743/01a178ef-b57e-7689-84c4-01c17490b0db.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy upscale amenities in our spacious community lounge, featuring a gourmet kitchen island, comfortable seating, and stunning views. Perfect for resident gatherings.",
      "link": "false",
      "alt_text": "A modern kitchen and dining area with a large island and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(67).jpg"
    },
    {
      "id": "ec_7d29752e32dfb1cc7ca581c8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-b57e-7689-84c4-01c17490b0db.webp",
      "image_media": {
        "alt_text": "Modern community lounge with dining tables, a kitchen island, and large windows overlooking the outdoors.",
        "public_id": "01a178ef-b57e-7689-84c4-01c17490b0db",
        "storage_key": "property/6737460151189743/01a178ef-b57e-7689-84c4-01c17490b0db.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy upscale amenities in our spacious community lounge, featuring a gourmet kitchen island, comfortable seating, and stunning views. Perfect for resident gatherings.",
      "link": "false",
      "alt_text": "A modern kitchen and dining area with a large island and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(67).jpg"
    },
    {
      "id": "ec_149a4269b549dc46c240e272",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-af43-7377-8e24-fbb1668ea70b.webp",
      "image_media": {
        "alt_text": "Modern lobby with a textured reception desk and seating area.",
        "public_id": "01a178ef-af43-7377-8e24-fbb1668ea70b",
        "storage_key": "property/6737460151189743/01a178ef-af43-7377-8e24-fbb1668ea70b.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Step into our elegant lobby, featuring a striking reception desk and comfortable seating areas perfect for guests or a quiet moment.",
      "link": "false",
      "alt_text": "A reception area with a white table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(49).jpg"
    },
    {
      "id": "ec_79396c7445b86573c93b4ea6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-c477-7535-a303-7dd4c29eff32.webp",
      "image_media": {
        "alt_text": "Interior view of a well-equipped fitness center with weight machines, treadmills, and stationary bikes.",
        "public_id": "01a178ef-c477-7535-a303-7dd4c29eff32",
        "storage_key": "property/6737460151189743/01a178ef-c477-7535-a303-7dd4c29eff32.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a full range of cardio and strength training equipment for your convenience.",
      "link": "false",
      "alt_text": "A gym with a variety of equipment including treadmills, stationary bikes, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(58).jpg"
    },
    {
      "id": "ec_da42dca512c06df9d32a3b56",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-ad80-768c-82ff-af3319946cca.webp",
      "image_media": {
        "alt_text": "Daymark Uptown logo on a textured wall behind a reception desk.",
        "public_id": "01a178ef-ad80-768c-82ff-af3319946cca",
        "storage_key": "property/6737460151189743/01a178ef-ad80-768c-82ff-af3319946cca.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Logo",
      "description": "The Daymark Uptown logo, featuring a lighthouse emblem and the property name, is displayed prominently on a stylish, textured wall. This image captures the modern and welcoming aesthetic of the property's entrance or lobby area.",
      "link": "false",
      "alt_text": "Daymark Uptown logo on a wall above a reception desk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(52).jpg"
    },
    {
      "id": "ec_b3834101d96ff368c10f6f71",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-e09f-75ff-8a0c-a2c619106e2e.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and tables.",
        "public_id": "01a178ef-e09f-75ff-8a0c-a2c619106e2e",
        "storage_key": "property/6737460151189743/01a178ef-e09f-75ff-8a0c-a2c619106e2e.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool and luxurious hot tub, surrounded by comfortable seating and vibrant red umbrellas.",
      "link": "false",
      "alt_text": "A patio with a table and chairs under a canopy.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(64).jpg"
    },
    {
      "id": "ec_5ed1a9a33ab19b95b377c5f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-c793-7039-bfb6-4647ae78dbeb.webp",
      "image_media": {
        "alt_text": "Outdoor courtyard with a fire pit, lounge chairs, and seating area.",
        "public_id": "01a178ef-c793-7039-bfb6-4647ae78dbeb",
        "storage_key": "property/6737460151189743/01a178ef-c793-7039-bfb6-4647ae78dbeb.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Gather around the modern fire pit and comfortable seating in the outdoor courtyard. Perfect for enjoying a cozy evening.",
      "link": "false",
      "alt_text": "A brick fire pit sits in the middle of a patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(55).jpg"
    },
    {
      "id": "ec_2c516f5d404a3b8ae42c2309",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-d2f1-7159-b01a-fb419eda8c4a.webp",
      "image_media": {
        "alt_text": "Outdoor pool and jacuzzi area with lounge chairs and tables.",
        "public_id": "01a178ef-d2f1-7159-b01a-fb419eda8c4a",
        "storage_key": "property/6737460151189743/01a178ef-d2f1-7159-b01a-fb419eda8c4a.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor pool and soothing jacuzzi, complete with comfortable lounge chairs and shaded seating areas. Perfect for enjoying a sunny day or a cool evening.",
      "link": "false",
      "alt_text": "A pool surrounded by red seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(72).jpg"
    },
    {
      "id": "ec_19f836c72d11815a05935795",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178f0-068e-777e-9eca-468fb26fe474.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with large windows and brick accents.",
        "public_id": "01a178f0-068e-777e-9eca-468fb26fe474",
        "storage_key": "property/6737460151189743/01a178f0-068e-777e-9eca-468fb26fe474.webp",
        "width": 1800,
        "height": 1236
      },
      "title": "Community",
      "description": "Exterior view of a contemporary apartment building showcasing its modern architecture, large windows, and inviting brick details, set against a backdrop of a cloudy sky and autumn foliage.",
      "link": "false",
      "alt_text": "A modern multi-story building with a parking lot in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(46).jpg"
    },
    {
      "id": "ec_8f4ace19b02948a257a0e4a1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-fcc3-7129-b49d-f3bf5be24691.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with retail on the ground floor.",
        "public_id": "01a178ef-fcc3-7129-b49d-f3bf5be24691",
        "storage_key": "property/6737460151189743/01a178ef-fcc3-7129-b49d-f3bf5be24691.webp",
        "width": 2048,
        "height": 1151
      },
      "title": "Community",
      "description": "Modern multifamily building featuring mixed-use retail and residential spaces, with a striking architectural design and balconies overlooking the street.",
      "link": "false",
      "alt_text": "A large building with a black roof and a tower with a spire is surrounded by cars and other buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(36)_websize.jpg"
    },
    {
      "id": "ec_b9643982843e607cbc89a19c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a19e0b-d4be-763e-9705-ec7746fa6dd5.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with retail spaces on the ground floor.",
        "public_id": "01a19e0b-d4be-763e-9705-ec7746fa6dd5",
        "storage_key": "property/6737460151189743/01a19e0b-d4be-763e-9705-ec7746fa6dd5.webp",
        "width": 1004,
        "height": 564
      },
      "title": "Community",
      "description": "View of the exterior of a contemporary apartment building, showcasing its architectural design and ground-floor retail spaces.",
      "link": "false",
      "alt_text": "A large building with a black roof and a tower with a spire is surrounded by cars and other buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(41).jpg"
    },
    {
      "id": "ec_1626860739c087f93695963b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a178ef-ff6f-70bb-9994-b4c1f9b3157c.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern multifamily property on a sunny day with surrounding streets and trees.",
        "public_id": "01a178ef-ff6f-70bb-9994-b4c1f9b3157c",
        "storage_key": "property/6737460151189743/01a178ef-ff6f-70bb-9994-b4c1f9b3157c.webp",
        "width": 3072,
        "height": 1725
      },
      "title": "Community",
      "description": "Discover modern apartment living in this stunning multifamily property, featuring a striking architectural design and prime urban location.",
      "link": "false",
      "alt_text": "A large building with a black roof and a clock tower sits in the middle of a busy intersection.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Daymark-Uptown_Favorites%20(60).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_dfd7d5723913c65417899573",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Shortwave Coffee",
      "poi_type": "Restaurants",
      "poi_address": "1477 W Lake St, Minneapolis, MN 55408, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-5f37-70da-804c-cad501a21e0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-5f37-70da-804c-cad501a21e0a",
        "storage_key": "property/6737460151189743/01a17def-5f37-70da-804c-cad501a21e0a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6128032616583777971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shortwave-coffee",
      "poi_latitude": "44.9482218",
      "poi_longitude": "-93.3005567",
      "poi_miles_from_property": "1 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f1a-6aa4-7193-aac0-f5052997e881.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f1a-6aa4-7193-aac0-f5052997e881",
        "storage_key": "property/6737460151189743/01a03f1a-6aa4-7193-aac0-f5052997e881.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJmX-qAwAn9ocRs857czIlC1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_043715554d0a640e37cfa045",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Barbette",
      "poi_type": "Restaurants",
      "poi_address": "1600 W Lake St, Minneapolis, MN 55408, USA",
      "poi_short_description": "All-day neighborhood bistro with a vibrant, hip ambiance presenting French fare & live music.",
      "poi_long_description": "All-day neighborhood bistro with a vibrant, hip ambiance presenting French fare & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-ae1f-769c-a868-04385c8530b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-ae1f-769c-a868-04385c8530b7",
        "storage_key": "property/6737460151189743/01a03f15-ae1f-769c-a868-04385c8530b7.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://www.barbette.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2818900666872890258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barbette",
      "poi_latitude": "44.9484892",
      "poi_longitude": "-93.3022357",
      "poi_miles_from_property": "436 ft",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 612-827-5710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c38-7329-ac55-615e7a522e75",
        "storage_key": "property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7SRKvfUn9ocRkgMSqji_Hic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_23a9f3ab08f52f67e071e19b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Bryant Lake Bowl and Theater",
      "poi_type": "Entertainment",
      "poi_address": "810 W Lake St, Minneapolis, MN 55408, USA",
      "poi_short_description": "Funky alley & bar hosts DJs plus music & theater performers while serving a simple American menu.",
      "poi_long_description": "Funky alley & bar hosts DJs plus music & theater performers while serving a simple American menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-b083-759a-8aa9-89dc4ec10831.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-b083-759a-8aa9-89dc4ec10831",
        "storage_key": "property/6737460151189743/01a03f15-b083-759a-8aa9-89dc4ec10831.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bryantlakebowl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5389449810521333560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bryant-lake-bowl-and-theater",
      "poi_latitude": "44.9485233",
      "poi_longitude": "-93.2901423",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 612-825-3737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c38-7329-ac55-615e7a522e75",
        "storage_key": "property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqRmGeoYn9ocROJ_rUgwsy0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "ec_a091d85e5090069170982b35",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Isles Bun & Coffee",
      "poi_type": "Restaurants",
      "poi_address": "1424 W 28th St, Minneapolis, MN 55408, USA",
      "poi_short_description": "Specializing in cinnamon rolls, this tiny bakery also offers other baked goods & coffee drinks.",
      "poi_long_description": "Specializing in cinnamon rolls, this tiny bakery also offers other baked goods & coffee drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f1a-1845-75f6-bd72-b2537a8ad6be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f1a-1845-75f6-bd72-b2537a8ad6be",
        "storage_key": "property/6737460151189743/01a03f1a-1845-75f6-bd72-b2537a8ad6be.webp",
        "width": 1008,
        "height": 567
      },
      "poi_business_url": "http://www.islesbun.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6029335072258493234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "isles-bun--coffee",
      "poi_latitude": "44.9521666",
      "poi_longitude": "-93.2986782",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 612-870-4466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c38-7329-ac55-615e7a522e75",
        "storage_key": "property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXRFWDoAn9ocRMovFrU2ArFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "ec_5b6e537a3549d18126690236",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Black Walnut Bakery",
      "poi_type": "Restaurants",
      "poi_address": "3157 Hennepin Ave S, Minneapolis, MN 55408, USA",
      "poi_short_description": "Upscale pastries, cakes & sandwiches in a relaxed cafe with floor-to-ceiling windows & a terrace.",
      "poi_long_description": "Upscale pastries, cakes & sandwiches in a relaxed cafe with floor-to-ceiling windows & a terrace.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-afd6-755f-802a-900939700c62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-afd6-755f-802a-900939700c62",
        "storage_key": "property/6737460151189743/01a03f15-afd6-755f-802a-900939700c62.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.blackwalnutbakery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10382209337079600767&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-walnut-bakery",
      "poi_latitude": "44.9448905",
      "poi_longitude": "-93.2981247",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 612-353-6552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c38-7329-ac55-615e7a522e75",
        "storage_key": "property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlcYXIogn9ocRf5ZfgGIEFZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "ec_dc8730a7a1745d600bb1542a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "BODEGA TACO BAR 3",
      "poi_type": "Restaurants",
      "poi_address": "2829 Hennepin Ave, Minneapolis, MN 55408, USA",
      "poi_short_description": "Vibrant Mexican restaurant serving signature birria tacos and birria ramen.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f1a-1aea-7779-93c7-dc5942055e5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f1a-1aea-7779-93c7-dc5942055e5c",
        "storage_key": "property/6737460151189743/01a03f1a-1aea-7779-93c7-dc5942055e5c.webp",
        "width": 1098,
        "height": 1280
      },
      "poi_business_url": "http://www.labodegataco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2663032803307284510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bodega-taco-bar-3",
      "poi_latitude": "44.95099630000001",
      "poi_longitude": "-93.2980712",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 612-434-6539",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c38-7329-ac55-615e7a522e75",
        "storage_key": "property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFbho9ogn9ocRHuhXqjn-9CQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_a0284ca30ba425441b2d3400",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Troubadour Wine Bar",
      "poi_type": "Restaurants",
      "poi_address": "2827 Hennepin Ave, Minneapolis, MN 55408, USA",
      "poi_short_description": "Snug, homey bar featuring an array of wines by the glass & bottle, plus snacks & nightly live music.",
      "poi_long_description": "Snug, homey bar featuring an array of wines by the glass & bottle, plus snacks & nightly live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-b6c0-76ae-b7aa-266652d4afd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-b6c0-76ae-b7aa-266652d4afd4",
        "storage_key": "property/6737460151189743/01a03f15-b6c0-76ae-b7aa-266652d4afd4.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://www.troubadourwinebar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15742945443524043345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "troubadour-wine-bar",
      "poi_latitude": "44.9510917",
      "poi_longitude": "-93.2980194",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 612-871-4073",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-a47b-76c3-8af6-120f866d8a9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17def-a47b-76c3-8af6-120f866d8a9a",
        "storage_key": "property/6737460151189743/01a17def-a47b-76c3-8af6-120f866d8a9a.webp",
        "width": 153,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cpkI4An9ocRUeKan3gteto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "ec_e0cbb05f22d137661af45c09",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Uncommon Grounds Coffeehouse",
      "poi_type": "Restaurants",
      "poi_address": "2809 Hennepin Ave, Minneapolis, MN 55408, USA",
      "poi_short_description": "Coffeehouse brewing upmarket coffees & teas in the homey setting of a renovated Victorian house.",
      "poi_long_description": "Coffeehouse brewing upmarket coffees & teas in the homey setting of a renovated Victorian house.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f1a-1c22-714c-b5df-c68f2ca2f589.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f1a-1c22-714c-b5df-c68f2ca2f589",
        "storage_key": "property/6737460151189743/01a03f1a-1c22-714c-b5df-c68f2ca2f589.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3568503922712666926&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uncommon-grounds-coffeehouse",
      "poi_latitude": "44.9515397",
      "poi_longitude": "-93.2979682",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 612-872-4811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f1a-6aa4-7193-aac0-f5052997e881.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f1a-6aa4-7193-aac0-f5052997e881",
        "storage_key": "property/6737460151189743/01a03f1a-6aa4-7193-aac0-f5052997e881.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJsQcQF4An9ocRLmPgNGnfhTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_af132b02ec1107198f4d6776",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Corner Coffee Uptown",
      "poi_type": "Restaurants",
      "poi_address": "1414 W 28th St, Minneapolis, MN 55408, USA",
      "poi_short_description": "This chill coffee shop using carefully sourced beans also offers sandwiches & frequent live music.",
      "poi_long_description": "This chill coffee shop using carefully sourced beans also offers sandwiches & frequent live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-5ae7-777f-afde-c78190d45073.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-5ae7-777f-afde-c78190d45073",
        "storage_key": "property/6737460151189743/01a17def-5ae7-777f-afde-c78190d45073.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://corner.coffee/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6381306616219044688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corner-coffee-uptown",
      "poi_latitude": "44.9521471",
      "poi_longitude": "-93.2976927",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 612-367-4743",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f1a-6aa4-7193-aac0-f5052997e881.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f1a-6aa4-7193-aac0-f5052997e881",
        "storage_key": "property/6737460151189743/01a03f1a-6aa4-7193-aac0-f5052997e881.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJuRIbD4An9ocRUAuWzo70jlg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_f5b718d91625be9b459f9bce",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Rinata Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2451 Hennepin Ave S, Minneapolis, MN 55405, USA",
      "poi_short_description": "Intimate trattoria offering a simple menu starring housemade pastas & pizzas plus wine & cocktails.",
      "poi_long_description": "Intimate trattoria offering a simple menu starring housemade pastas & pizzas plus wine & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f1a-220d-719d-acf6-52ff250c1290.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f1a-220d-719d-acf6-52ff250c1290",
        "storage_key": "property/6737460151189743/01a03f1a-220d-719d-acf6-52ff250c1290.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.rinatarestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11556637164779126164&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rinata-restaurant",
      "poi_latitude": "44.9575556",
      "poi_longitude": "-93.295",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 612-374-8998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c38-7329-ac55-615e7a522e75",
        "storage_key": "property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEZL-o9Yys1IRlL28jEVsYaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_cbdebfcd1b12fee1dc6ce038",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Mi Lindo Guanajuato",
      "poi_type": "Restaurants",
      "poi_address": "205 E Lake St, Minneapolis, MN 55408, USA",
      "poi_short_description": "Cozy Mexican restaurant serving small plates and comfort food in a casual setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-5e67-7327-887e-910287d04e60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-5e67-7327-887e-910287d04e60",
        "storage_key": "property/6737460151189743/01a17def-5e67-7327-887e-910287d04e60.webp",
        "width": 1280,
        "height": 907
      },
      "poi_business_url": "https://milindoguanajuatomn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2008388625291463108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mi-lindo-guanajuato",
      "poi_latitude": "44.9482163",
      "poi_longitude": "-93.2738115",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 612-345-5737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c38-7329-ac55-615e7a522e75",
        "storage_key": "property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPSjFq-0n9ocRxMluVdA63xs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_d523409ccef20cc73a81baab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Tom’s Thai",
      "poi_type": "Restaurants",
      "poi_address": "1601 W Lake St, Minneapolis, MN 55408, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-656f-75d0-a6f6-115d2f2e00f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-656f-75d0-a6f6-115d2f2e00f7",
        "storage_key": "property/6737460151189743/01a17def-656f-75d0-a6f6-115d2f2e00f7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tomsthaiusa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16744472408964652793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toms-thai",
      "poi_latitude": "44.9482024",
      "poi_longitude": "-93.3022676",
      "poi_miles_from_property": "443 ft",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 612-446-3051",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c38-7329-ac55-615e7a522e75",
        "storage_key": "property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99mefBwn9ocR-d6qn_BQYOg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "ec_e63c3ba87acb7944a161db60",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "OG ZaZa Pizza & Catering-UPTOWN",
      "poi_type": "Restaurants",
      "poi_address": "1440 W Lake St, Minneapolis, MN 55408, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-6ff4-742b-b219-7143c6378003.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-6ff4-742b-b219-7143c6378003",
        "storage_key": "property/6737460151189743/01a17def-6ff4-742b-b219-7143c6378003.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://ogzazamn.com/uptown?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=6514009160753234874&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "og-zaza-pizza--catering-uptown",
      "poi_latitude": "44.9485954",
      "poi_longitude": "-93.2993774",
      "poi_miles_from_property": "302 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 612-248-8996",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c38-7329-ac55-615e7a522e75",
        "storage_key": "property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWR9wrO4n9ocRukNWqtFoZlo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_10313f62ca98c35cc01cd8b0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Arizona Taco Co Uptown",
      "poi_type": "Restaurants",
      "poi_address": "1405 W Lake St, Minneapolis, MN 55408, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-7e04-736f-b24f-c0ff7c142d19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-7e04-736f-b24f-c0ff7c142d19",
        "storage_key": "property/6737460151189743/01a17def-7e04-736f-b24f-c0ff7c142d19.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3981492158583649603&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arizona-taco-co-uptown",
      "poi_latitude": "44.9482034",
      "poi_longitude": "-93.2973191",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 612-489-6580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c38-7329-ac55-615e7a522e75",
        "storage_key": "property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJETioccAn9ocRQ7Vh_AUaQTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_6ac1479eb6d8436c41f2f727",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Lake & Irving Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "1513 W Lake St, Minneapolis, MN 55408, USA",
      "poi_short_description": "Warm gastropub serving a refined menu of eclectic American bites, plus craft beer & cocktails.",
      "poi_long_description": "Warm gastropub serving a refined menu of eclectic American bites, plus craft beer & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-7a87-7487-b626-dcbd95a301b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-7a87-7487-b626-dcbd95a301b4",
        "storage_key": "property/6737460151189743/01a17def-7a87-7487-b626-dcbd95a301b4.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.lakeandirving.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3880387903493099472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake--irving-restaurant--bar",
      "poi_latitude": "44.9482582",
      "poi_longitude": "-93.3016115",
      "poi_miles_from_property": "272 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 612-354-2453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c38-7329-ac55-615e7a522e75",
        "storage_key": "property/6737460151189743/019d01a6-9c38-7329-ac55-615e7a522e75.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvdIP0X4n9ocR0M9tMj3o2TU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_ee47e416011c899d52d703dd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Lunds & Byerlys Uptown Minneapolis",
      "poi_type": "Shopping & Retail",
      "poi_address": "1450 W Lake St ID:2001, Minneapolis, MN 55408, USA",
      "poi_short_description": "Upscale grocery store offering high-quality produce and diverse deli selections.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-b884-73de-8f61-d7a710e2451e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-b884-73de-8f61-d7a710e2451e",
        "storage_key": "property/6737460151189743/01a03f15-b884-73de-8f61-d7a710e2451e.webp",
        "width": 1280,
        "height": 803
      },
      "poi_business_url": "https://lundsandbyerlys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5992264435036822913&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lunds--byerlys-uptown-minneapolis",
      "poi_latitude": "44.9485336",
      "poi_longitude": "-93.3002057",
      "poi_miles_from_property": "240 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 612-825-2440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c36-71b7-8529-079f2aedad60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c36-71b7-8529-079f2aedad60",
        "storage_key": "property/6737460151189743/019d01a6-9c36-71b7-8529-079f2aedad60.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_81lPn8n9ocRgZ2TWsHMKFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_f3c850d57d2bb55b2d305942",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Kowalski's Markets",
      "poi_type": "Shopping & Retail",
      "poi_address": "2440 Hennepin Ave, Minneapolis, MN 55405, USA",
      "poi_short_description": "Supermarket chain stocking a range of everyday & gourmet items, with a focus on local producers.",
      "poi_long_description": "Supermarket chain stocking a range of everyday & gourmet items, with a focus on local producers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-bc42-720f-ab7d-6f7c35e0bd4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-bc42-720f-ab7d-6f7c35e0bd4d",
        "storage_key": "property/6737460151189743/01a03f15-bc42-720f-ab7d-6f7c35e0bd4d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.kowalskis.com/location/uptown-market-wine-shop?utm_source=google%20my%20business&utm_medium=organic&utm_campaign=Uptown%20Market%20GMB%20Listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1649490599667712125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kowalskis-markets",
      "poi_latitude": "44.9578285",
      "poi_longitude": "-93.2960858",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 612-377-3448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c36-71b7-8529-079f2aedad60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c36-71b7-8529-079f2aedad60",
        "storage_key": "property/6737460151189743/019d01a6-9c36-71b7-8529-079f2aedad60.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa_rXhNYys1IRfUCKBfYq5BY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_8c0b8b82e7a6206bcf37bffe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Cub - Minneapolis Uptown",
      "poi_type": "Shopping & Retail",
      "poi_address": "1104 Lagoon Ave, Minneapolis, MN 55408, USA",
      "poi_short_description": "Grocery store featuring an in-store deli, bakery, and pharmacy.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f1a-23b1-72ec-8108-2ca77e1d5465.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f1a-23b1-72ec-8108-2ca77e1d5465",
        "storage_key": "property/6737460151189743/01a03f1a-23b1-72ec-8108-2ca77e1d5465.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cub.com/store/cub/pages/uptown-store-details",
      "poi_directions_map_url": "https://maps.google.com/?cid=2123017325864815470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cub---minneapolis-uptown",
      "poi_latitude": "44.9497779",
      "poi_longitude": "-93.2938289",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 612-823-1563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c36-71b7-8529-079f2aedad60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c36-71b7-8529-079f2aedad60",
        "storage_key": "property/6737460151189743/019d01a6-9c36-71b7-8529-079f2aedad60.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqRUMOMEys1IRbgsseAJ5dh0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_54a01528bcc1c59b060d8263",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Walgreens Specialty Pharmacy at Allina Med Clinic/Uptown Row",
      "poi_type": "Health and Wellness",
      "poi_address": "1221 W Lake St #200, Minneapolis, MN 55408, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-b996-709b-a778-6a4de5492327.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-b996-709b-a778-6a4de5492327",
        "storage_key": "property/6737460151189743/01a03f15-b996-709b-a778-6a4de5492327.webp",
        "width": 750,
        "height": 421
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1221+w+lake+st-minneapolis-mn-55408/id=11916",
      "poi_directions_map_url": "https://maps.google.com/?cid=16425413238751874991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-specialty-pharmacy-at-allina-med-clinicuptown-row",
      "poi_latitude": "44.9481666",
      "poi_longitude": "-93.2947895",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 612-824-1036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-ee24-77ca-99e4-13837a864a13.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f15-ee24-77ca-99e4-13837a864a13",
        "storage_key": "property/6737460151189743/01a03f15-ee24-77ca-99e4-13837a864a13.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPzOlXYEn9ocRr8_NqFDK8uM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_61963a2343fe32b3a7fd336a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Speedway",
      "poi_type": "Transportation & Transit",
      "poi_address": "801 W Lake St, Minneapolis, MN 55408, USA",
      "poi_short_description": "Gas-station & convenience-store chain with grab-&-go food, plus hot & cold beverages.",
      "poi_long_description": "Gas-station & convenience-store chain with grab-&-go food, plus hot & cold beverages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f1a-24b2-7315-9ef1-45bb7c52ff87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f1a-24b2-7315-9ef1-45bb7c52ff87",
        "storage_key": "property/6737460151189743/01a03f1a-24b2-7315-9ef1-45bb7c52ff87.webp",
        "width": 1280,
        "height": 833
      },
      "poi_business_url": "https://www.speedway.com/locations/mn/minneapolis/801-w-lake-st-46387?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=12073349672465976669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "speedway",
      "poi_latitude": "44.9479607",
      "poi_longitude": "-93.2897839",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 612-823-6046",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f1a-6a95-756e-8606-fbb17ff1345c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f1a-6a95-756e-8606-fbb17ff1345c",
        "storage_key": "property/6737460151189743/01a03f1a-6a95-756e-8606-fbb17ff1345c.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJtS4Z4IUn9ocRXc1pTI8njac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_76af08b86d15a3032b451d82",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Frattallone's Hardware & Garden",
      "poi_type": "Shopping & Retail",
      "poi_address": "2737 Hennepin Ave, Minneapolis, MN 55408, USA",
      "poi_short_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_long_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-80c7-70bd-9642-3c6691d1a732.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-80c7-70bd-9642-3c6691d1a732",
        "storage_key": "property/6737460151189743/01a17def-80c7-70bd-9642-3c6691d1a732.webp",
        "width": 1132,
        "height": 1280
      },
      "poi_business_url": "http://www.frattallones.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=273806876620026994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frattallones-hardware--garden",
      "poi_latitude": "44.9526762",
      "poi_longitude": "-93.2976863",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 612-238-0196",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c32-7296-8e99-1c9e6044b66c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c32-7296-8e99-1c9e6044b66c",
        "storage_key": "property/6737460151189743/019d01a6-9c32-7296-8e99-1c9e6044b66c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBeybTNUys1IRcvT-UefBzAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hardware_store"
    },
    {
      "id": "ec_b6bbb7b142be504aa94dd225",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Seven Points Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "3001 Hennepin Ave, Minneapolis, MN 55408, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7757423627050870955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seven-points-square",
      "poi_latitude": "44.9477875",
      "poi_longitude": "-93.2979719",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9fdc-744a-a00d-4c524067ff70",
        "storage_key": "property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ08vKDQAn9ocRq-iWLrDnp2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "ec_a485ab5345852029c5facc6a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "The UPS Store",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2801 Hennepin Ave S, Minneapolis, MN 55408, USA",
      "poi_short_description": "Store offering shipping, packaging, printing & other services, plus office supplies.",
      "poi_long_description": "Store offering shipping, packaging, printing & other services, plus office supplies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-7a2c-738f-a0e0-d02461040836.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-7a2c-738f-a0e0-d02461040836",
        "storage_key": "property/6737460151189743/01a17def-7a2c-738f-a0e0-d02461040836.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.theupsstore.com/mn/minneapolis/2801-hennepin-ave-s?utm_source=Yext&utm_medium=organic&utm_campaign=Listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=6403764800433826236&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ups-store",
      "poi_latitude": "44.9517783",
      "poi_longitude": "-93.2978837",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 612-822-0022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c32-7296-8e99-1c9e6044b66c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c32-7296-8e99-1c9e6044b66c",
        "storage_key": "property/6737460151189743/019d01a6-9c32-7296-8e99-1c9e6044b66c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ52_oBYAn9ocRvCkCSyi-3lg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shipping_service"
    },
    {
      "id": "ec_82c5cfd06ba6adf8fc273585",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Uptown Row",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1221 W Lake St, Minneapolis, MN 55408, USA",
      "poi_short_description": "Versatile commercial complex featuring various shops and dining options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-8316-726f-9b2e-1b8694e6cf6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-8316-726f-9b2e-1b8694e6cf6a",
        "storage_key": "property/6737460151189743/01a17def-8316-726f-9b2e-1b8694e6cf6a.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.uptownrow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14438151620320523844&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uptown-row",
      "poi_latitude": "44.9481595",
      "poi_longitude": "-93.2951864",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 612-445-0201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9fdc-744a-a00d-4c524067ff70",
        "storage_key": "property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPzOlXYEn9ocRRHZv7maeXsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "ec_0bdbb03da6a54fd8aa0447eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Lake Harriet Community School, Lower Campus",
      "poi_type": "Education",
      "poi_address": "4030 Chowen Ave S, Minneapolis, MN 55410, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-8450-7068-8c43-f6caedd13006.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-8450-7068-8c43-f6caedd13006",
        "storage_key": "property/6737460151189743/01a17def-8450-7068-8c43-f6caedd13006.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lakeharriet.mpschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14000449186294040460&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-harriet-community-school-lower-campus",
      "poi_latitude": "44.9288727",
      "poi_longitude": "-93.3258828",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 612-668-3210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c35-735f-a643-36b2541fec06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c35-735f-a643-36b2541fec06",
        "storage_key": "property/6737460151189743/019d01a6-9c35-735f-a643-36b2541fec06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq6pqdjkn9ocRjIf2fFuWS8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_f21321f951e1c432b8a83362",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Lake Harriet Community School, Upper Campus",
      "poi_type": "Education",
      "poi_address": "4912 Vincent Ave S, Minneapolis, MN 55410, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://lakeharriet.mpschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14050496441579820763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-harriet-community-school-upper-campus",
      "poi_latitude": "44.9135882",
      "poi_longitude": "-93.3168754",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 612-668-3310",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c35-735f-a643-36b2541fec06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c35-735f-a643-36b2541fec06",
        "storage_key": "property/6737460151189743/019d01a6-9c35-735f-a643-36b2541fec06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ14LKR-Am9ocR21ZBJhJk_cI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_90066291ea8e006450419dd8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Kenwood Elementary School",
      "poi_type": "Education",
      "poi_address": "2013 Penn Ave S, Minneapolis, MN 55405, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://kenwood.mpschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=827073018628548048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenwood-elementary-school",
      "poi_latitude": "44.9623101",
      "poi_longitude": "-93.3077991",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 612-668-2760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c35-735f-a643-36b2541fec06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c35-735f-a643-36b2541fec06",
        "storage_key": "property/6737460151189743/019d01a6-9c35-735f-a643-36b2541fec06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy3RvayUzs1IR0CWqRodaegs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_f3e23af947a16aa2289c74d3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Anwatin Middle School",
      "poi_type": "Education",
      "poi_address": "256 Upton Ave S, Minneapolis, MN 55405, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-bde0-71c9-a423-ed5c4f7676dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-bde0-71c9-a423-ed5c4f7676dc",
        "storage_key": "property/6737460151189743/01a03f15-bde0-71c9-a423-ed5c4f7676dc.webp",
        "width": 1239,
        "height": 940
      },
      "poi_business_url": "https://anwatin.mpschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8457684804373208049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anwatin-middle-school",
      "poi_latitude": "44.9735492",
      "poi_longitude": "-93.3164274",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 612-668-2450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c35-735f-a643-36b2541fec06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c35-735f-a643-36b2541fec06",
        "storage_key": "property/6737460151189743/019d01a6-9c35-735f-a643-36b2541fec06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZZI3zxYzs1IR8Vvi0oS7X3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_d76b1b9d6f9f44e4805f98a9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Southwest High School",
      "poi_type": "Education",
      "poi_address": "3414 W 47th St, Minneapolis, MN 55410, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f1a-2790-7368-aa62-0a58be35190c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f1a-2790-7368-aa62-0a58be35190c",
        "storage_key": "property/6737460151189743/01a03f1a-2790-7368-aa62-0a58be35190c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://southwest.mpls.k12.mn.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1057685906322944085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southwest-high-school",
      "poi_latitude": "44.918504",
      "poi_longitude": "-93.3247697",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 612-668-3030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c35-735f-a643-36b2541fec06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c35-735f-a643-36b2541fec06",
        "storage_key": "property/6737460151189743/019d01a6-9c35-735f-a643-36b2541fec06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQcu7OCEn9ocRVfBQWrqnrQ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_98196aef3b7588b2776d10dd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Intown On Lake Condominiums",
      "poi_type": "Education",
      "poi_address": "1 W Lake St, Minneapolis, MN 55408, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-c4fd-70e2-997c-9c24b685d391.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-c4fd-70e2-997c-9c24b685d391",
        "storage_key": "property/6737460151189743/01a03f15-c4fd-70e2-997c-9c24b685d391.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2419895892412475746&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "intown-on-lake-condominiums",
      "poi_latitude": "44.948147299999995",
      "poi_longitude": "-93.2788362",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 763-843-2593",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9fdc-744a-a00d-4c524067ff70",
        "storage_key": "property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBS5uoIwn9ocRYimsNH4ylSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "condominium_complex"
    },
    {
      "id": "ec_ce8920fa0ed267be404996fd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Urban Ventures: Cornwell Early Learning Center",
      "poi_type": "Education",
      "poi_address": "2924 4th Ave S, Minneapolis, MN 55408, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-c36c-77d8-afa1-2f2023e06dc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-c36c-77d8-afa1-2f2023e06dc1",
        "storage_key": "property/6737460151189743/01a03f15-c36c-77d8-afa1-2f2023e06dc1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cornwellearlylearningcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9598301091342902242&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urban-ventures-cornwell-early-learning-center",
      "poi_latitude": "44.9494231",
      "poi_longitude": "-93.2711723",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 612-545-9840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c35-735f-a643-36b2541fec06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c35-735f-a643-36b2541fec06",
        "storage_key": "property/6737460151189743/019d01a6-9c35-735f-a643-36b2541fec06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqTg3zHkn9ocR4uO8FP0DNIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_d5ec6c290c162e5f3952c2a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Lake Harriet Montessori School",
      "poi_type": "Education",
      "poi_address": "915 W 45th St, Minneapolis, MN 55419, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.lhms.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4183243589793505669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-harriet-montessori-school",
      "poi_latitude": "44.921234",
      "poi_longitude": "-93.2918031",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 612-825-8517",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c35-735f-a643-36b2541fec06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c35-735f-a643-36b2541fec06",
        "storage_key": "property/6737460151189743/019d01a6-9c35-735f-a643-36b2541fec06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvZSWkq4n9ocRhWGSkuHdDTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_39428f6051678249c962dd78",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Minneapolis College",
      "poi_type": "Education",
      "poi_address": "1501 Hennepin Ave, Minneapolis, MN 55403, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03e7f-56a8-71d5-ae08-4234f9ec1d17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e7f-56a8-71d5-ae08-4234f9ec1d17",
        "storage_key": "property/6737460151189743/01a03e7f-56a8-71d5-ae08-4234f9ec1d17.webp",
        "width": 1280,
        "height": 895
      },
      "poi_business_url": "http://www.minneapolis.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18306040378800738842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minneapolis-college",
      "poi_latitude": "44.9728923",
      "poi_longitude": "-93.2832714",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 612-659-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c35-735f-a643-36b2541fec06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c35-735f-a643-36b2541fec06",
        "storage_key": "property/6737460151189743/019d01a6-9c35-735f-a643-36b2541fec06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnWP8Zuoys1IRGhJgJrweDP4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_d254c8f029ef69d5d703bc91",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Uptown Theater",
      "poi_type": "Entertainment",
      "poi_address": "2900 Hennepin Ave, Minneapolis, MN 55408, USA",
      "poi_short_description": "Renovated event venue hosting live music and comedy performances.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-c5f4-721f-a529-3afd47b2d881.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-c5f4-721f-a529-3afd47b2d881",
        "storage_key": "property/6737460151189743/01a03f15-c5f4-721f-a529-3afd47b2d881.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://uptowntheatermn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7371338285163250244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uptown-theater",
      "poi_latitude": "44.9491401",
      "poi_longitude": "-93.2984745",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 612-464-7050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-a487-75be-b133-104a1e268788.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17def-a487-75be-b133-104a1e268788",
        "storage_key": "property/6737460151189743/01a17def-a487-75be-b133-104a1e268788.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwnYvfsn9ocRRIJkhh1BTGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_335add564dff05e70aeb1dc2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Walker Art Center",
      "poi_type": "Entertainment",
      "poi_address": "725 Vineland Pl, Minneapolis, MN 55403, USA",
      "poi_short_description": "Acclaimed venue featuring contemporary art in a variety of media, plus a sculpture garden & bistro.",
      "poi_long_description": "Acclaimed venue featuring contemporary art in a variety of media, plus a sculpture garden & bistro.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-83f5-7048-889b-711d84e9ebd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-83f5-7048-889b-711d84e9ebd1",
        "storage_key": "property/6737460151189743/01a17def-83f5-7048-889b-711d84e9ebd1.webp",
        "width": 885,
        "height": 1280
      },
      "poi_business_url": "https://walkerart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13983112962245836178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walker-art-center",
      "poi_latitude": "44.9681442",
      "poi_longitude": "-93.2886494",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 612-375-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-a489-75e4-9d8a-3ba7d8a360b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17def-a489-75e4-9d8a-3ba7d8a360b9",
        "storage_key": "property/6737460151189743/01a17def-a489-75e4-9d8a-3ba7d8a360b9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkXzI4m4rs1IRkr3SSCf_DcI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_3f4b871f07da471f1b8cee97",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Minneapolis Sculpture Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "725 Vineland Pl, Minneapolis, MN 55403, USA",
      "poi_short_description": "An 11-acre preserve featuring a conservatory, an arbor & 40+ sculptures by notable modern artists.",
      "poi_long_description": "An 11-acre preserve featuring a conservatory, an arbor & 40+ sculptures by notable modern artists.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17ded-9297-747a-96bc-38ad6b6c019d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17ded-9297-747a-96bc-38ad6b6c019d",
        "storage_key": "property/6737460151189743/01a17ded-9297-747a-96bc-38ad6b6c019d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walkerart.org/garden/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6037934690900938095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minneapolis-sculpture-garden",
      "poi_latitude": "44.969547899999995",
      "poi_longitude": "-93.2897803",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 612-375-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-a2ea-7156-9b86-a4eb18aa5bc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-a2ea-7156-9b86-a4eb18aa5bc0",
        "storage_key": "property/6737460151189743/019d01a6-a2ea-7156-9b86-a4eb18aa5bc0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCVqalcIys1IRb40obJwNy1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_5b4b72ad97843311d89734f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Minneapolis Institute of Art",
      "poi_type": "Entertainment",
      "poi_address": "2400 3rd Ave S, Minneapolis, MN 55404, USA",
      "poi_short_description": "5,000-year span of fine & decorative arts ranging from a mummy to paintings by European masters.",
      "poi_long_description": "5,000-year span of fine & decorative arts ranging from a mummy to paintings by European masters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17ded-8a04-75db-81cf-bbfa8c36baf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17ded-8a04-75db-81cf-bbfa8c36baf0",
        "storage_key": "property/6737460151189743/01a17ded-8a04-75db-81cf-bbfa8c36baf0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://new.artsmia.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14207980514366553254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minneapolis-institute-of-art",
      "poi_latitude": "44.958546",
      "poi_longitude": "-93.2741616",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 888-642-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9fde-757e-9df2-417c22e0dda7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9fde-757e-9df2-417c22e0dda7",
        "storage_key": "property/6737460151189743/019d01a6-9fde-757e-9df2-417c22e0dda7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0k6WbEys1IRpnx9LgDjLMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_eb9572c0f06ce09db7da4941",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Lake Harriet Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4135 W Lake Harriet Pkwy, Minneapolis, MN 55409, USA",
      "poi_short_description": "Scenic setting providing biking & walking trails, water activities & a castle-inspired band shell.",
      "poi_long_description": "Scenic setting providing biking & walking trails, water activities & a castle-inspired band shell.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17ded-97b8-766e-8531-f31a2e9290c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17ded-97b8-766e-8531-f31a2e9290c7",
        "storage_key": "property/6737460151189743/01a17ded-97b8-766e-8531-f31a2e9290c7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.minneapolisparks.org/parks-destinations/parks-lakes/lake_harriet_park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8458957997012670662&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-harriet-regional-park",
      "poi_latitude": "44.9281483",
      "poi_longitude": "-93.3076867",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 612-230-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-a2ea-7156-9b86-a4eb18aa5bc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-a2ea-7156-9b86-a4eb18aa5bc0",
        "storage_key": "property/6737460151189743/019d01a6-a2ea-7156-9b86-a4eb18aa5bc0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMQ-JEQ4n9ocRxtjjFXtBZHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_99bea23fe42024c4ea64b98c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "James Ballentine “Uptown” VFW Post 246",
      "poi_type": "Entertainment",
      "poi_address": "2916 Lyndale Ave S, Minneapolis, MN 55408, USA",
      "poi_short_description": "Trendy veteran-focused venue with bars, a full menu & entertainment such as live music & karaoke.",
      "poi_long_description": "Trendy veteran-focused venue with bars, a full menu & entertainment such as live music & karaoke.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-8838-70a8-b9d4-e01229435703.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-8838-70a8-b9d4-e01229435703",
        "storage_key": "property/6737460151189743/01a17def-8838-70a8-b9d4-e01229435703.webp",
        "width": 1179,
        "height": 657
      },
      "poi_business_url": "http://www.uptownvfw.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6293282551556252765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-ballentine-uptown-vfw-post-246",
      "poi_latitude": "44.9494391",
      "poi_longitude": "-93.2884337",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 612-823-6233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-ee3a-738d-bd84-1e1c5a0272a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f15-ee3a-738d-bd84-1e1c5a0272a1",
        "storage_key": "property/6737460151189743/01a03f15-ee3a-738d-bd84-1e1c5a0272a1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK9ovbfQn9ocRXaSsLCM7Vlc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_e43d75ca4f0e846b27f35a8a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "First Avenue",
      "poi_type": "Entertainment",
      "poi_address": "701 N 1st Ave, Minneapolis, MN 55403, USA",
      "poi_short_description": "Housed in an old depot, this rock venue & tiny side bar have hosted & launched many acts since 1970.",
      "poi_long_description": "Housed in an old depot, this rock venue & tiny side bar have hosted & launched many acts since 1970.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-c855-75bb-92da-b01552a649e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-c855-75bb-92da-b01552a649e2",
        "storage_key": "property/6737460151189743/01a03f15-c855-75bb-92da-b01552a649e2.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://first-avenue.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12518072061981438790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-avenue",
      "poi_latitude": "44.978531499999995",
      "poi_longitude": "-93.2759978",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 612-338-8388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-a489-75e4-9d8a-3ba7d8a360b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17def-a489-75e4-9d8a-3ba7d8a360b9",
        "storage_key": "property/6737460151189743/01a17def-a489-75e4-9d8a-3ba7d8a360b9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP6i4fJEys1IRRjMlfzcgua0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_9a9d0501a195aeb4ce684590",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Guthrie Theater",
      "poi_type": "Entertainment",
      "poi_address": "818 S 2nd St, Minneapolis, MN 55415, USA",
      "poi_short_description": "Landmark venue for wide-ranging plays on 3 stages, full-service dining, several bars & river views.",
      "poi_long_description": "Landmark venue for wide-ranging plays on 3 stages, full-service dining, several bars & river views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-c79d-7288-9487-97454f6a14b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-c79d-7288-9487-97454f6a14b5",
        "storage_key": "property/6737460151189743/01a03f15-c79d-7288-9487-97454f6a14b5.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.guthrietheater.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14415037625030132595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "guthrie-theater",
      "poi_latitude": "44.9781701",
      "poi_longitude": "-93.2558665",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 612-377-2224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-a489-75e4-9d8a-3ba7d8a360b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17def-a489-75e4-9d8a-3ba7d8a360b9",
        "storage_key": "property/6737460151189743/01a17def-a489-75e4-9d8a-3ba7d8a360b9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dxNCmQts1IRc8PPh1iADMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_e9cc2ef61013d86db27d7209",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Mill City Museum",
      "poi_type": "Entertainment",
      "poi_address": "704 S 2nd St, Minneapolis, MN 55401, USA",
      "poi_short_description": "History of the flour industry told through interactive exhibits in the rebuilt ruins of an old mill.",
      "poi_long_description": "History of the flour industry told through interactive exhibits in the rebuilt ruins of an old mill.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-89db-72ab-b96b-bfda4a327ffe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-89db-72ab-b96b-bfda4a327ffe",
        "storage_key": "property/6737460151189743/01a17def-89db-72ab-b96b-bfda4a327ffe.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mnhs.org/millcity",
      "poi_directions_map_url": "https://maps.google.com/?cid=11052270807054118706&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mill-city-museum",
      "poi_latitude": "44.9787748",
      "poi_longitude": "-93.25726",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 612-341-7555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9fde-757e-9df2-417c22e0dda7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9fde-757e-9df2-417c22e0dda7",
        "storage_key": "property/6737460151189743/019d01a6-9fde-757e-9df2-417c22e0dda7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9eTEmWMts1IRMm_h172NYZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "ec_32b2d41b3b8a69dc0aae6efd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Abbott Northwestern Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "800 E 28th St, Minneapolis, MN 55407, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-8900-76a8-9381-dc58e6f91dfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-8900-76a8-9381-dc58e6f91dfa",
        "storage_key": "property/6737460151189743/01a17def-8900-76a8-9381-dc58e6f91dfa.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://account.allinahealth.org/locations/1509?utm_source=gmb&utm_medium=organic&utm_content=web-url&utm_campaign=gmb_website&utm_term=Abbott-Northwestern-Hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=8810814823065207451&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abbott-northwestern-hospital",
      "poi_latitude": "44.9537467",
      "poi_longitude": "-93.261861",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 612-863-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9ffa-7508-9033-b99995b12ec8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9ffa-7508-9033-b99995b12ec8",
        "storage_key": "property/6737460151189743/019d01a6-9ffa-7508-9033-b99995b12ec8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJp5pK-6oys1IRm0KMXmZNRno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_476cda6dc344434e756722e3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Allina Health Urgent Care – Greenway (Minneapolis)",
      "poi_type": "Health and Wellness",
      "poi_address": "3270 W Lake St Ste 3264, Minneapolis, MN 55416, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-c9f6-736b-8408-03f814bd3f4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-c9f6-736b-8408-03f814bd3f4d",
        "storage_key": "property/6737460151189743/01a03f15-c9f6-736b-8408-03f814bd3f4d.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "https://account.allinahealth.org/locations/1880?utm_source=gmb&utm_medium=organic&utm_content=web-url&utm_campaign=gmb_website&utm_term=Allina-Health-Urgent-Care-Greenway",
      "poi_directions_map_url": "https://maps.google.com/?cid=1828202768561725610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allina-health-urgent-care--greenway-minneapolis",
      "poi_latitude": "44.9489481",
      "poi_longitude": "-93.3218358",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 612-262-8890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9fdc-744a-a00d-4c524067ff70",
        "storage_key": "property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnwxIj3In9ocRquCBVbsUXxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_737c6f89c4f7610219a57faa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Allina Health Piper Building Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "Piper Building, 913 E 26th St, Minneapolis, MN 55404, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-89a2-7797-99f1-cac4ab575fbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-89a2-7797-99f1-cac4ab575fbf",
        "storage_key": "property/6737460151189743/01a17def-89a2-7797-99f1-cac4ab575fbf.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "https://account.allinahealth.org/locations/1717?utm_source=gmb&utm_medium=organic&utm_content=web-url&utm_campaign=gmb_website&utm_term=Allina-Health-Piper-Building-Pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=835984205934775011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allina-health-piper-building-pharmacy",
      "poi_latitude": "44.9551805",
      "poi_longitude": "-93.260902",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 612-863-5370",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-ee24-77ca-99e4-13837a864a13.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f15-ee24-77ca-99e4-13837a864a13",
        "storage_key": "property/6737460151189743/01a03f15-ee24-77ca-99e4-13837a864a13.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz24ca_8n9ocR40qUwDQDmgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_9fba3fce27e5ed34220d44d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "MinuteClinic at CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "1010 W Lake St, Minneapolis, MN 55408, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f1a-2e2a-733f-b310-19cc091546bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f1a-2e2a-733f-b310-19cc091546bd",
        "storage_key": "property/6737460151189743/01a03f1a-2e2a-733f-b310-19cc091546bd.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.cvs.com/minuteclinic/clinic-locator/mn/minneapolis/8285.html?WT.mc_id=LS_mc_google_carenav_8285",
      "poi_directions_map_url": "https://maps.google.com/?cid=13086455472754055192&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minuteclinic-at-cvs",
      "poi_latitude": "44.9488055",
      "poi_longitude": "-93.2927128",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 866-389-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9fdc-744a-a00d-4c524067ff70",
        "storage_key": "property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJARNYnGYn9ocRGNh43uptnLU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_716f2e6e40efd629185eaa18",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "411 N Washington Ave #250, Minneapolis, MN 55401, USA",
      "poi_short_description": "Heart rate-based group fitness center focused on cardio and strength training.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-8a1d-751e-9771-fa0dbf64f858.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-8a1d-751e-9771-fa0dbf64f858",
        "storage_key": "property/6737460151189743/01a17def-8a1d-751e-9771-fa0dbf64f858.webp",
        "width": 990,
        "height": 1280
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/minneapolis-minnesota-0277?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=17016889426807252373&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "44.9854746",
      "poi_longitude": "-93.2745383",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 612-217-8665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9fdc-744a-a00d-4c524067ff70",
        "storage_key": "property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb5UwFyEzs1IRlWXyOsYiKOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_2ac300ea9e9a4fde78041dc0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2910 Lyndale Ave S, Minneapolis, MN 55408, USA",
      "poi_short_description": "Well-maintained 24/7 gym featuring extensive strength training equipment and personal coaching services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-cb3f-72a3-9846-b1dcad58dc66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-cb3f-72a3-9846-b1dcad58dc66",
        "storage_key": "property/6737460151189743/01a03f15-cb3f-72a3-9846-b1dcad58dc66.webp",
        "width": 750,
        "height": 546
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/minneapolis-minnesota-4246/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=4246",
      "poi_directions_map_url": "https://maps.google.com/?cid=10915069903219396647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "44.9497522",
      "poi_longitude": "-93.2884242",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 612-345-7753",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9fdc-744a-a00d-4c524067ff70",
        "storage_key": "property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV9yanYgn9ocRJxDzFz8eepc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_76ecd31894a90c2c3776397d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Pilates Underground",
      "poi_type": "Health and Wellness",
      "poi_address": "3153 Hennepin Ave S Unit 210, Minneapolis, MN 55408, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-989b-74fe-a0a5-249015db2ecb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-989b-74fe-a0a5-249015db2ecb",
        "storage_key": "property/6737460151189743/01a17def-989b-74fe-a0a5-249015db2ecb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.pilates-underground.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16236844691030033225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pilates-underground",
      "poi_latitude": "44.9449067",
      "poi_longitude": "-93.2980531",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 612-986-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9fdc-744a-a00d-4c524067ff70",
        "storage_key": "property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrdNCNdQys1IRSUMIUjjcVOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_95bb53be6bcda60eccb47310",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "MOV Hot Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "3252 W Lake St Ste B, Minneapolis, MN 55416, USA",
      "poi_short_description": "Welcoming yoga studio offering hot yoga and barre classes in a supportive community environment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-8d9e-72cd-8315-d9ddef2b3aff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-8d9e-72cd-8315-d9ddef2b3aff",
        "storage_key": "property/6737460151189743/01a17def-8d9e-72cd-8315-d9ddef2b3aff.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.movhotyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1463371823039290365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mov-hot-yoga",
      "poi_latitude": "44.9487217",
      "poi_longitude": "-93.3219309",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 612-920-3004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9fdc-744a-a00d-4c524067ff70",
        "storage_key": "property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ13v-OQAn9ocR_ZuSduvwThQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_cb22fd6b6087415eee1660e7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Crossroads Mnisota",
      "poi_type": "Health and Wellness",
      "poi_address": "2657 Dupont Ave S, Minneapolis, MN 55408, USA",
      "poi_short_description": "Community-focused yoga studio offering Vinyasa and Yin classes with an emphasis on meditation and philosophy.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-8f40-771f-988c-94e233577216.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-8f40-771f-988c-94e233577216",
        "storage_key": "property/6737460151189743/01a17def-8f40-771f-988c-94e233577216.webp",
        "width": 938,
        "height": 938
      },
      "poi_business_url": "http://www.crossroadsmnisota.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17757990578057678079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossroads-mnisota",
      "poi_latitude": "44.9538875",
      "poi_longitude": "-93.292876",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 612-314-5246",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9fdc-744a-a00d-4c524067ff70",
        "storage_key": "property/6737460151189743/019d01a6-9fdc-744a-a00d-4c524067ff70.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUfHWa9Mys1IR_4zcSVgOcfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_8faba7776c5505561698c0a2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Lake of the Isles Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2500 Lake of the Isles Pkwy E, Minneapolis, MN 55416, USA",
      "poi_short_description": "Path-lined park offers areas for ice skating, canoeing & picnicking, plus an off-leash dog park.",
      "poi_long_description": "Path-lined park offers areas for ice skating, canoeing & picnicking, plus an off-leash dog park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-d0f0-7078-b6d4-ba930a0103ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-d0f0-7078-b6d4-ba930a0103ad",
        "storage_key": "property/6737460151189743/01a03f15-d0f0-7078-b6d4-ba930a0103ad.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.minneapolisparks.org/parks__destinations/parks__lakes/lake_of_the_isles_park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5097314520378848513&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-of-the-isles-park",
      "poi_latitude": "44.9516474",
      "poi_longitude": "-93.3076005",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 612-230-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-a2ea-7156-9b86-a4eb18aa5bc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-a2ea-7156-9b86-a4eb18aa5bc0",
        "storage_key": "property/6737460151189743/019d01a6-a2ea-7156-9b86-a4eb18aa5bc0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvVk4ty0zs1IRATWfr4xMvUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_8845545a381f85c89ec0971e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Bde Maka Ska",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3000 E Bde Maka Ska Pkwy, Minneapolis, MN 55408, USA",
      "poi_short_description": "Swimming, water sports & watercraft rentals, plus separate 3-mile loop paths for walkers & bikers.",
      "poi_long_description": "Swimming, water sports & watercraft rentals, plus separate 3-mile loop paths for walkers & bikers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-8f96-7752-8d83-345bcb785fa2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-8f96-7752-8d83-345bcb785fa2",
        "storage_key": "property/6737460151189743/01a17def-8f96-7752-8d83-345bcb785fa2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.minneapolisparks.org/parks__destinations/parks__lakes/bde_maka_ska_park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16201749792186862234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bde-maka-ska",
      "poi_latitude": "44.948163699999995",
      "poi_longitude": "-93.3065193",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 612-230-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-a2ea-7156-9b86-a4eb18aa5bc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-a2ea-7156-9b86-a4eb18aa5bc0",
        "storage_key": "property/6737460151189743/019d01a6-a2ea-7156-9b86-a4eb18aa5bc0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIVIDC2on9ocRmooOb5gt2OA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a54fc5fb1b1195aec97a8481",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Cedar Lake Point Beach",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Cedar Lake Pkwy, Minneapolis, MN 55416, USA",
      "poi_short_description": "Year-round recreational refuge with waterside paths, sandy beaches & 2 lakes for fishing & canoeing.",
      "poi_long_description": "Year-round recreational refuge with waterside paths, sandy beaches & 2 lakes for fishing & canoeing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-9338-70f8-b8c1-5bbf34b8ab6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-9338-70f8-b8c1-5bbf34b8ab6f",
        "storage_key": "property/6737460151189743/01a17def-9338-70f8-b8c1-5bbf34b8ab6f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8972688833018742858&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cedar-lake-point-beach",
      "poi_latitude": "44.960487",
      "poi_longitude": "-93.3227354",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 612-230-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-a2ea-7156-9b86-a4eb18aa5bc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-a2ea-7156-9b86-a4eb18aa5bc0",
        "storage_key": "property/6737460151189743/019d01a6-a2ea-7156-9b86-a4eb18aa5bc0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJp0qMD0gzs1IRSkgyTPRkhXw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7aac0b71a2a3088f073ccd85",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Bryant Square Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3101 Bryant Ave S, Minneapolis, MN 55408, USA",
      "poi_short_description": "City park featuring a hillside amphitheater with summer concerts, a winter ice rink & sports fields.",
      "poi_long_description": "City park featuring a hillside amphitheater with summer concerts, a winter ice rink & sports fields.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-950c-7196-87e6-dde30d7117bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-950c-7196-87e6-dde30d7117bf",
        "storage_key": "property/6737460151189743/01a17def-950c-7196-87e6-dde30d7117bf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.minneapolisparks.org/parks-destinations/parks-lakes/bryant_square_park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15137732161316685565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bryant-square-park",
      "poi_latitude": "44.946140799999995",
      "poi_longitude": "-93.29033520000002",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 612-370-4907",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-a2ea-7156-9b86-a4eb18aa5bc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-a2ea-7156-9b86-a4eb18aa5bc0",
        "storage_key": "property/6737460151189743/019d01a6-a2ea-7156-9b86-a4eb18aa5bc0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQxBCoUn9ocR_YZJlDIHFNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0b39f2dfb590447eec28d97c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Kenwood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2101 W Franklin Ave, Minneapolis, MN 55405, USA",
      "poi_short_description": "This 33-acre tract offers multiple sports facilities, paths, grassy areas & a community center.",
      "poi_long_description": "This 33-acre tract offers multiple sports facilities, paths, grassy areas & a community center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-9316-75cb-821e-38ce74497888.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-9316-75cb-821e-38ce74497888",
        "storage_key": "property/6737460151189743/01a17def-9316-75cb-821e-38ce74497888.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.minneapolisparks.org/parks__destinations/parks__lakes/kenwood_park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13354570956603340264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenwood-park",
      "poi_latitude": "44.9644377",
      "poi_longitude": "-93.3057153",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 612-370-4941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-a2ea-7156-9b86-a4eb18aa5bc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-a2ea-7156-9b86-a4eb18aa5bc0",
        "storage_key": "property/6737460151189743/019d01a6-a2ea-7156-9b86-a4eb18aa5bc0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJsS2zOiQzs1IR6DUXjIf3VLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d97775d338280528219f137b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "William Berry Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3810 Richfield Rd, Minneapolis, MN 55410, USA",
      "poi_short_description": "Park with a lake and picnic tables.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-9319-708b-99c2-bcf496611a1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-9319-708b-99c2-bcf496611a1f",
        "storage_key": "property/6737460151189743/01a17def-9319-708b-99c2-bcf496611a1f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.minneapolisparks.org/parks__destinations/parks__lakes/william_berry_park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11658802281201081948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-berry-park",
      "poi_latitude": "44.9316725",
      "poi_longitude": "-93.3104772",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 612-230-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-a2ea-7156-9b86-a4eb18aa5bc0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-a2ea-7156-9b86-a4eb18aa5bc0",
        "storage_key": "property/6737460151189743/019d01a6-a2ea-7156-9b86-a4eb18aa5bc0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb9-e9w0n9ocRXB6BXedizKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4dc0a28f796b667dbe3d199f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Uptown Transit Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Minneapolis, MN 55408, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-d87d-777e-ba97-bdca5529ea9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-d87d-777e-ba97-bdca5529ea9a",
        "storage_key": "property/6737460151189743/01a03f15-d87d-777e-ba97-bdca5529ea9a.webp",
        "width": 1280,
        "height": 684
      },
      "poi_business_url": "http://www.metrotransit.org/uptown-transit-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=15379628613307455673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uptown-transit-station",
      "poi_latitude": "44.9500785",
      "poi_longitude": "-93.2978535",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 612-373-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-ee1f-756e-937d-96a162752dcf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f15-ee1f-756e-937d-96a162752dcf",
        "storage_key": "property/6737460151189743/01a03f15-ee1f-756e-937d-96a162752dcf.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJBW8Fy4En9ocRudifMb1qb9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_0adba0db7df5ced5fb57fd46",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Hennepin Ave & Lake St W",
      "poi_type": "Transportation & Transit",
      "poi_address": "Minneapolis, MN 55408, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f1a-31c9-71dd-ad4f-d847e2ce8a2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f1a-31c9-71dd-ad4f-d847e2ce8a2b",
        "storage_key": "property/6737460151189743/01a03f1a-31c9-71dd-ad4f-d847e2ce8a2b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3487817321297298266&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hennepin-ave--lake-st-w",
      "poi_latitude": "44.948215",
      "poi_longitude": "-93.29819",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-ee2f-75b3-b616-7702954ab903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f15-ee2f-75b3-b616-7702954ab903",
        "storage_key": "property/6737460151189743/01a03f15-ee2f-75b3-b616-7702954ab903.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJi62h-4En9ocRWkNh3V83ZzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_80d1839f540f2f2561941a53",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Lyndale Ave S & Lake St W",
      "poi_type": "Transportation & Transit",
      "poi_address": "Minneapolis, MN 55408, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=654553622911451952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lyndale-ave-s--lake-st-w",
      "poi_latitude": "44.948547999999995",
      "poi_longitude": "-93.288234",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-ee2f-75b3-b616-7702954ab903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f15-ee2f-75b3-b616-7702954ab903",
        "storage_key": "property/6737460151189743/01a03f15-ee2f-75b3-b616-7702954ab903.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ31Z4rIgn9ocRMAMVVA1xFQk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_a0db906552e2d179f025f5a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Hennepin Ave S & Lagoon Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Minneapolis, MN 55408, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9655734348273317518&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hennepin-ave-s--lagoon-ave",
      "poi_latitude": "44.948837999999995",
      "poi_longitude": "-93.298377",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-ee2f-75b3-b616-7702954ab903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f15-ee2f-75b3-b616-7702954ab903",
        "storage_key": "property/6737460151189743/01a03f15-ee2f-75b3-b616-7702954ab903.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJL-HC4IEn9ocRjnZeQjsPAIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_dad9c008969670dff22fa448",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Midtown Greenway",
      "poi_type": "Entertainment",
      "poi_address": "Midtown Greenway, Minneapolis, MN 55407, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://midtowngreenway.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6579786764084658833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midtown-greenway",
      "poi_latitude": "44.9503728",
      "poi_longitude": "-93.2672678",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-a48b-748a-90aa-a5f9e06a96ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a17def-a48b-748a-90aa-a5f9e06a96ca",
        "storage_key": "property/6737460151189743/01a17def-a48b-748a-90aa-a5f9e06a96ca.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJO0OnLwAn9ocRkUIVYzMZUFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "ec_0ffec8449635f0ea5fa177f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Lake Street Midtown Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Minneapolis, MN 55407, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f1a-34c7-72db-a125-e227ff935a9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f1a-34c7-72db-a125-e227ff935a9d",
        "storage_key": "property/6737460151189743/01a03f1a-34c7-72db-a125-e227ff935a9d.webp",
        "width": 1280,
        "height": 957
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9632489911716989244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-street-midtown-station",
      "poi_latitude": "44.948376",
      "poi_longitude": "-93.238823",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f17-3ca2-72cf-90d4-091e2837f1b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f17-3ca2-72cf-90d4-091e2837f1b0",
        "storage_key": "property/6737460151189743/01a03f17-3ca2-72cf-90d4-091e2837f1b0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ1P8lxgo9ocRPMlsIop6rYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_b2318f986ce4e4918a28d554",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "I-35w & Lake St Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Minneapolis, MN 55408, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f1a-33cc-7488-9344-853a9a70771b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f1a-33cc-7488-9344-853a9a70771b",
        "storage_key": "property/6737460151189743/01a03f1a-33cc-7488-9344-853a9a70771b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8588658760085207350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "i-35w--lake-st-station",
      "poi_latitude": "44.948626999999995",
      "poi_longitude": "-93.274658",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-ee2f-75b3-b616-7702954ab903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f15-ee2f-75b3-b616-7702954ab903",
        "storage_key": "property/6737460151189743/01a03f15-ee2f-75b3-b616-7702954ab903.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJOd3ECvQn9ocRNvnsO6MLMXc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_9bc3b80d37a948106f560f41",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Minneapolis-Saint Paul International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "4300 Glumack Dr, St Paul, MN 55111, USA",
      "poi_short_description": "International hub with direct light rail service to Downtown Minneapolis & the Mall of America.",
      "poi_long_description": "International hub with direct light rail service to Downtown Minneapolis & the Mall of America.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03e7f-af55-70cc-8cab-97ba2aa92ee9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e7f-af55-70cc-8cab-97ba2aa92ee9",
        "storage_key": "property/6737460151189743/01a03e7f-af55-70cc-8cab-97ba2aa92ee9.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.mspairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3158100295267399057&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minneapolis-saint-paul-international-airport",
      "poi_latitude": "44.8850593",
      "poi_longitude": "-93.2144354",
      "poi_miles_from_property": "12.9 mi",
      "poi_walking_minutes": "4 hours 43 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 612-726-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-a383-70fc-82e2-733e745ad9cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-a383-70fc-82e2-733e745ad9cb",
        "storage_key": "property/6737460151189743/019d01a6-a383-70fc-82e2-733e745ad9cb.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJB2rAhSov9ocRkTV4eHzT0ys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_920d761f35e0ff6fd0c999ce",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Children's Minnesota - Minneapolis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2525 Chicago Ave, Minneapolis, MN 55404, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-e211-7686-9f5f-190bc2417dbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-e211-7686-9f5f-190bc2417dbe",
        "storage_key": "property/6737460151189743/01a03f15-e211-7686-9f5f-190bc2417dbe.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.childrensmn.org/locations/minneapolis/?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_id=minneapolis-childrens-hospital&utm_content=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=2828323151284378822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-minnesota---minneapolis-hospital",
      "poi_latitude": "44.9561177",
      "poi_longitude": "-93.2618031",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 612-813-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9ffa-7508-9033-b99995b12ec8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9ffa-7508-9033-b99995b12ec8",
        "storage_key": "property/6737460151189743/019d01a6-9ffa-7508-9033-b99995b12ec8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ48Nrrasys1IRxpxRxus4QCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_69609b6e1f37d81c32374c55",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "M Health Fairview University of Minnesota Medical Center - East Bank",
      "poi_type": "Health and Wellness",
      "poi_address": "500 SE Harvard St, Minneapolis, MN 55455, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-99d6-7033-9779-cc20b351d9f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-99d6-7033-9779-cc20b351d9f5",
        "storage_key": "property/6737460151189743/01a17def-99d6-7033-9779-cc20b351d9f5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://mhealthfairview.org/locations/m-health-fairview-university-of-minnesota-medical-center---east-bank",
      "poi_directions_map_url": "https://maps.google.com/?cid=15715049760007388325&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "m-health-fairview-university-of-minnesota-medical-center---east-bank",
      "poi_latitude": "44.97120700000001",
      "poi_longitude": "-93.230731",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 612-273-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9ffa-7508-9033-b99995b12ec8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9ffa-7508-9033-b99995b12ec8",
        "storage_key": "property/6737460151189743/019d01a6-9ffa-7508-9033-b99995b12ec8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJO8cyHz0ts1IRpfzTrH4SF9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_2571c0049469c72be89653b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Hennepin Healthcare",
      "poi_type": "Health and Wellness",
      "poi_address": "701 Park Ave, Minneapolis, MN 55404, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-e1bb-72e3-baab-4a2a98d2b4de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-e1bb-72e3-baab-4a2a98d2b4de",
        "storage_key": "property/6737460151189743/01a03f15-e1bb-72e3-baab-4a2a98d2b4de.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5364710283124104956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hennepin-healthcare",
      "poi_latitude": "44.9724191",
      "poi_longitude": "-93.2620715",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 612-873-3180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9ffa-7508-9033-b99995b12ec8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9ffa-7508-9033-b99995b12ec8",
        "storage_key": "property/6737460151189743/019d01a6-9ffa-7508-9033-b99995b12ec8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJoaIY2Zkys1IR_F5_PJRHc0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_eb4fd6a787f633c4e32dac01",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "University of Minnesota",
      "poi_type": "Education",
      "poi_address": "Minneapolis, MN 55455, USA",
      "poi_short_description": "The Mississippi River bisects this urban research university known for management, education & law.",
      "poi_long_description": "The Mississippi River bisects this urban research university known for management, education & law.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03e7f-42b5-714b-8c77-ab3c1aae5ed1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e7f-42b5-714b-8c77-ab3c1aae5ed1",
        "storage_key": "property/6737460151189743/01a03e7f-42b5-714b-8c77-ab3c1aae5ed1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://twin-cities.umn.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16362166377837992312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-minnesota",
      "poi_latitude": "44.97399",
      "poi_longitude": "-93.2277285",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 612-625-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c35-735f-a643-36b2541fec06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c35-735f-a643-36b2541fec06",
        "storage_key": "property/6737460151189743/019d01a6-9c35-735f-a643-36b2541fec06.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_8cK92kts1IReJnfUqEXEuM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_00ab6f002c88f11535990637",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Target Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 Nicollet Mall, Minneapolis, MN 55403, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03e7f-bbd6-75c9-ac4d-8be9f64ab03c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e7f-bbd6-75c9-ac4d-8be9f64ab03c",
        "storage_key": "property/6737460151189743/01a03e7f-bbd6-75c9-ac4d-8be9f64ab03c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.target.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12859972463573983574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target-corporation",
      "poi_latitude": "44.9739975",
      "poi_longitude": "-93.2753023",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 612-304-6073",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9c32-7296-8e99-1c9e6044b66c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9c32-7296-8e99-1c9e6044b66c",
        "storage_key": "property/6737460151189743/019d01a6-9c32-7296-8e99-1c9e6044b66c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAe5o1pUys1IRVuGhENLMd7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_74c2975a08204a524c717e0c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "U.S. Bank Branch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "800 Nicollet Mall, Minneapolis, MN 55402, USA",
      "poi_short_description": "Full-service banking institution providing credit cards, loans, and investment services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-df10-76f1-8a36-2f089b575dcb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-df10-76f1-8a36-2f089b575dcb",
        "storage_key": "property/6737460151189743/01a03f15-df10-76f1-8a36-2f089b575dcb.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.usbank.com/locations/minnesota/minneapolis/800-nicollet-mall-bank-atm/?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=9848271995717534090&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "us-bank-branch",
      "poi_latitude": "44.9755906",
      "poi_longitude": "-93.2738748",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 612-659-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-ee31-75d7-a19d-ad9664fa9b4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f15-ee31-75d7-a19d-ad9664fa9b4a",
        "storage_key": "property/6737460151189743/01a03f15-ee31-75d7-a19d-ad9664fa9b4a.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJe6Jb3ZYys1IRisErpDMXrIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bank"
    },
    {
      "id": "ec_8463f9e00bf83af2acc3cd5f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Wells Fargo Bank",
      "poi_type": "Major Employers & Offices",
      "poi_address": "90 S 7th St Fl 2, Minneapolis, MN 55402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17def-9b5c-70bf-8f3a-707baafa303f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a17def-9b5c-70bf-8f3a-707baafa303f",
        "storage_key": "property/6737460151189743/01a17def-9b5c-70bf-8f3a-707baafa303f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.wellsfargo.com/mn/minneapolis/90-s-7th-st?utm_campaign=Local_Listings&utm_source=Google&group=Community_Bank&loc=WF09504",
      "poi_directions_map_url": "https://maps.google.com/?cid=5811843072324799170&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wells-fargo-bank",
      "poi_latitude": "44.976977",
      "poi_longitude": "-93.2708829",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 612-667-0654",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-ee31-75d7-a19d-ad9664fa9b4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f15-ee31-75d7-a19d-ad9664fa9b4a",
        "storage_key": "property/6737460151189743/01a03f15-ee31-75d7-a19d-ad9664fa9b4a.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJsRqsBpoys1IRwgo8WHvQp1A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bank"
    },
    {
      "id": "ec_5c1881d1a6cf84f3c6b497e3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Hennepin County Government Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 South 6th St, Minneapolis, MN 55487, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-e1d0-70fe-90cd-35c19e27f09d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f15-e1d0-70fe-90cd-35c19e27f09d",
        "storage_key": "property/6737460151189743/01a03f15-e1d0-70fe-90cd-35c19e27f09d.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.hennepincounty.gov/government/about/policies/government-center-building-plaza-rules",
      "poi_directions_map_url": "https://maps.google.com/?cid=16173898168372719458&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hennepin-county-government-center",
      "poi_latitude": "44.975769",
      "poi_longitude": "-93.266614",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 612-348-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f15-ee3a-738d-bd84-1e1c5a0272a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f15-ee3a-738d-bd84-1e1c5a0272a1",
        "storage_key": "property/6737460151189743/01a03f15-ee3a-738d-bd84-1e1c5a0272a1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK_p9a-oys1IRYm8y77A6deA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_1b31ba6f63e8120f52b3daca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "generator",
      "poi_name": "Minneapolis VA Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1 Veterans Dr, Minneapolis, MN 55417, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a03f1a-35f1-740b-a791-7d0d01c08ae7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f1a-35f1-740b-a791-7d0d01c08ae7",
        "storage_key": "property/6737460151189743/01a03f1a-35f1-740b-a791-7d0d01c08ae7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.va.gov/minneapolis-health-care/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3642700861927343425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minneapolis-va-medical-center",
      "poi_latitude": "44.9018834",
      "poi_longitude": "-93.2048785",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 612-725-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-9ffa-7508-9033-b99995b12ec8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a6-9ffa-7508-9033-b99995b12ec8",
        "storage_key": "property/6737460151189743/019d01a6-9ffa-7508-9033-b99995b12ec8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJTbNHjhYp9ocRQUUwUiJ5jTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "ec_665816e578666b09e4443b68",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_cf0cae83803a6a0681740820",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_964ff9ccafdda8325672ec4e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_bea9c1d109ba5b19c1686780",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_d8436e894efb4f19137ba1b4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_51a1d65e8ec28f4bd3810140",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_7fe88e528b73d33b53ed884a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "rating": "4",
      "name": "MiKe V",
      "text": "I've been living here for three months, and I couldn't be happier with my decision. The location is fantastic, the amenities are excellent, and the management team truly goes above and beyond to create a welcoming community. They regularly organize resident events and genuinely care about making this a great place to live.\n\nThere was a bit of miscommunication during the lease process, but I really appreciated how the team handled it. They made every effort to clarify the situation and accommodate my concerns, which speaks volumes about their commitment to residents.\n\nIf you're looking for a place to call home, I highly recommend giving this community a look. It's been a wonderful experience so far!",
      "date": "2026-06-29",
      "title": "false"
    },
    {
      "id": "ec_17c706f609cac2899f7cb3fb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "rating": "5",
      "name": "Melanie L",
      "text": "I’ve had a wonderful experience at this complex. The management team and staff are highly professional and genuinely care about resident feedback, addressing any concerns with urgency. The facilities are always spotless, and the amenities provide great value too. I highly recommend for anyone looking for a well-maintained and supportive living environment. Big shout-out to Sharon, Ben and James for their outstanding dedication to making Daymark an amazing place to live. We miss it here since moving, the community feel is truly one of a kind here in the Twin Cities. Thank you for a great few years :)",
      "date": "2026-05-03",
      "title": "false"
    },
    {
      "id": "ec_ac0cd5d820a846099efff39d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "rating": "5",
      "name": "Molly Falnes",
      "text": "It’s so hard to say goodbye to Daymark. It was the perfect oasis for me throughout my time living there. They made living there easy from start to finish. I always was impressed by the atmosphere of cozy and inviting in the spaces and fun activities throughout the week. I got to dance and watch movies and go to outing with them including goat Yoga and the Minnesota Zoo Spooktacular!! I was always welcomed by name at the front desk by Merrill, Sharon, and Mitch. I could always count on Jurell to fix anything that went awry. I am glad that I had a chapter with Daymark. I am sad to see my chapter come to a close. But I am also grateful that I got the opportunity to be apart of that community",
      "date": "2025-10-16",
      "title": "false"
    },
    {
      "id": "ec_49529279015471f56c1b9afe",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "rating": "5",
      "name": "Mechanic Hansen",
      "text": "Ben was wonderful to work with. I had a lot of difficulty moving in due to past rental history. I think we called every day for three weeks and finally got in. It was unbelievable. How on it he was.",
      "date": "2026-06-20",
      "title": "false"
    },
    {
      "id": "ec_d1a2d62350f7611917dafbd9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "rating": "5",
      "name": "Lukas Zha",
      "text": "This review is a shout-out to the wonderful service and hospitality we received from the leasing agent, Sharon, during our visit. When we stumbled upon The Daymark while exploring the neighborhood, we walked in early one morning requesting a tour before office hours. Sharon, without hesitation, gave us a spontaneous tour of the entire building. She was professional, welcoming, and extremely well-spoken. As prospective residents new to the Midwest, that left a strong and positive impression on us — not just of the building, but of the city.\n\nAfter learning more about our preferences, she followed up a few days later and coordinated a second tour so we could see currently occupied units, taking the extra time to arrange that with residents. That kind of effort isn’t required, but it made a real difference in how well we could evaluate the place.\n\nIt was obvious that she truly cares about her community and loves her job. She knows most residents by name and knows the building down to every single corner, including the trees in the courtyard. She remembered our earlier conversations, took her time showing us every feature of the units, and genuinely listened to us, instead of treating us as a transaction to be pushed through. All of this was very meaningful to us. Deciding between two very good apartment communities was already challenging enough, and Sharon’s hospitality and care made that decision even tougher.\n\nWe ultimately chose a different neighborhood for personal reasons, but that had nothing to do with the experience at The Daymark. For anyone considering Uptown and looking for a leasing experience and a community that is warm, respectful, attentive, and genuinely helpful, I would strongly recommend checking out The Daymark and asking for Sharon.",
      "date": "2026-01-10",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_b31bb8d1-f51c-45da-9019-c1bda5de33da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17df9-174f-760b-acdf-3686be8b9de3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Staircase and kitchen area in a modern apartment with high ceilings.",
        "public_id": "01a17df9-174f-760b-acdf-3686be8b9de3",
        "storage_key": "property/6737460151189743/01a17df9-174f-760b-acdf-3686be8b9de3.webp",
        "width": 3014,
        "height": 1596
      },
      "virtual_tour_title": "N109 Holmes",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=N1cV28tKa9j"
    },
    {
      "id": "custom_01796a7f-d047-418b-bed2-447e6d6e9a6d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a8-a053-74e6-abdc-d814a59a8575.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern living room and kitchen area with a fireplace, stainless steel appliances, and a dining table.",
        "public_id": "019d01a8-a053-74e6-abdc-d814a59a8575",
        "storage_key": "property/6737460151189743/019d01a8-a053-74e6-abdc-d814a59a8575.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Townhome",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=S7CJCMQvb5y"
    },
    {
      "id": "custom_cd53a343-adbb-408c-ad38-c893a6fd9146",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a8-8d3d-7109-8913-713867657753.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern leasing office with two reception desks, contemporary pendant lighting, and a minimalist seating area.",
        "public_id": "019d01a8-8d3d-7109-8913-713867657753",
        "storage_key": "property/6737460151189743/019d01a8-8d3d-7109-8913-713867657753.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Lobby",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=8zJiown2aCw"
    },
    {
      "id": "custom_08161ae7-b623-4d87-ac27-66afdde83e41",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a8-9676-75ae-8938-3ec8718986c9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern living room and open kitchen with island and stainless steel appliances.",
        "public_id": "019d01a8-9676-75ae-8938-3ec8718986c9",
        "storage_key": "property/6737460151189743/019d01a8-9676-75ae-8938-3ec8718986c9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2 Bedroom Unit #628",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=j1pRKeusXPG"
    },
    {
      "id": "custom_57c34b77-45a4-415d-8ffe-7a54406eea66",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a8-8d33-76de-9727-f4d0c906ef12.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with island and stainless steel appliances connected to living room with large window.",
        "public_id": "019d01a8-8d33-76de-9727-f4d0c906ef12",
        "storage_key": "property/6737460151189743/019d01a8-8d33-76de-9727-f4d0c906ef12.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1 Bedroom Model #630",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=CPHVqb7RNxY"
    },
    {
      "id": "custom_26ec320a-e6e2-4a10-80fb-122e9eca5125",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a8-96ab-7460-9715-c70e01ecc998.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern shared kitchen with stainless steel appliances and seating area.",
        "public_id": "019d01a8-96ab-7460-9715-c70e01ecc998",
        "storage_key": "property/6737460151189743/019d01a8-96ab-7460-9715-c70e01ecc998.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Kitchen / Laundry",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=L9VVxgSbCB9"
    },
    {
      "id": "custom_8da23086-ad60-4d84-8c43-e6356f53fd13",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17dff-eb02-73b8-b612-ca43de721725.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry, leading to a living area.",
        "public_id": "01a17dff-eb02-73b8-b612-ca43de721725",
        "storage_key": "property/6737460151189743/01a17dff-eb02-73b8-b612-ca43de721725.webp",
        "width": 3016,
        "height": 1310
      },
      "virtual_tour_title": "#S415 Carver",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=g3iPb4fQvri"
    },
    {
      "id": "custom_dbb2d8e7-fb7b-42e6-98fc-0649c64c1bd1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a8-aa4b-7582-9c88-725dc0a8f03b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern lounge area with a gourmet kitchen, comfortable seating, and dining space.",
        "public_id": "019d01a8-aa4b-7582-9c88-725dc0a8f03b",
        "storage_key": "property/6737460151189743/019d01a8-aa4b-7582-9c88-725dc0a8f03b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club Room",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=yU6ubAt6rZz"
    },
    {
      "id": "custom_eee0a01c-dc82-43de-a092-338d31013690",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a8-b457-7563-92f9-5c327598b4d1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern open-concept living area with a fireplace and a kitchen island.",
        "public_id": "019d01a8-b457-7563-92f9-5c327598b4d1",
        "storage_key": "property/6737460151189743/019d01a8-b457-7563-92f9-5c327598b4d1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "#S511 Gull",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7AhHikXxyEt"
    },
    {
      "id": "custom_023be42a-5ce9-4ce6-b4b3-e7f8669f3ad8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a8-ba70-76be-891d-d6537ac0a972.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and island, open to living area.",
        "public_id": "019d01a8-ba70-76be-891d-d6537ac0a972",
        "storage_key": "property/6737460151189743/019d01a8-ba70-76be-891d-d6537ac0a972.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "#S517 Diamond",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=86if6QHToF9"
    },
    {
      "id": "custom_f59ef195-bb88-4e7e-9acd-7650165f6b95",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a8-b1ad-701c-847d-587aa860d09a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern apartment kitchen with white countertops, stainless steel sink, and pendant lights.",
        "public_id": "019d01a8-b1ad-701c-847d-587aa860d09a",
        "storage_key": "property/6737460151189743/019d01a8-b1ad-701c-847d-587aa860d09a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "#S502 Pepi",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=51dhyWLpmaM"
    },
    {
      "id": "custom_441f617b-d9a8-4b92-a220-83d518df0c74",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a8-9694-7283-8b24-f29e32aae82c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern apartment building lobby with elevators and modern art.",
        "public_id": "019d01a8-9694-7283-8b24-f29e32aae82c",
        "storage_key": "property/6737460151189743/019d01a8-9694-7283-8b24-f29e32aae82c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Lobby",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=KgiUQzEmnm2"
    },
    {
      "id": "custom_376eb2af-b94b-4c3a-b2c7-249124eda650",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a8-bc53-760d-a9ed-0377053b45e7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with gray cabinets, white subway tile backsplash, and stainless steel appliances.",
        "public_id": "019d01a8-bc53-760d-a9ed-0377053b45e7",
        "storage_key": "property/6737460151189743/019d01a8-bc53-760d-a9ed-0377053b45e7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "#S540 Crystal",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=beau66vQgdU"
    },
    {
      "id": "custom_83ee0bff-b0fe-4f1e-bcf9-e6cc5da0daa5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a8-8d67-716d-87a6-dc1545c292ca.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Gym with various weight machines and cardio equipment, including treadmills and ellipticals.",
        "public_id": "019d01a8-8d67-716d-87a6-dc1545c292ca",
        "storage_key": "property/6737460151189743/019d01a8-8d67-716d-87a6-dc1545c292ca.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FtvQaBdGTc4"
    },
    {
      "id": "custom_0ff59df9-8d79-4340-89c2-1371b7c46273",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17dee-68fd-77fa-9c64-0a5b5f49b017.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a17dee-68fd-77fa-9c64-0a5b5f49b017",
        "storage_key": "property/6737460151189743/01a17dee-68fd-77fa-9c64-0a5b5f49b017.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "#S203 Elmo",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=GzNkFJrKvLi"
    },
    {
      "id": "custom_ea2de58f-5ca4-49f7-a841-211020f85457",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17dee-9dfb-755c-8483-dae218eda460.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a17dee-9dfb-755c-8483-dae218eda460",
        "storage_key": "property/6737460151189743/01a17dee-9dfb-755c-8483-dae218eda460.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "#S549 Boyer",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=DbnQFgdLAmK"
    },
    {
      "id": "custom_b82f1107-5f80-45a6-8476-b0bde6679d38",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17dee-bcb9-743b-9576-347941423e6f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a17dee-bcb9-743b-9576-347941423e6f",
        "storage_key": "property/6737460151189743/01a17dee-bcb9-743b-9576-347941423e6f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "#S501 Itaska",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=XDGNjUHSF7Z"
    },
    {
      "id": "custom_2edceb33-e3df-404c-b3c7-b034de8909ab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17dee-b4aa-77bf-8816-319179065d67.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a17dee-b4aa-77bf-8816-319179065d67",
        "storage_key": "property/6737460151189743/01a17dee-b4aa-77bf-8816-319179065d67.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "#S520 Como",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=KQLXSP2gQjs"
    },
    {
      "id": "custom_e599245e-86ed-4f06-a299-149503a27b69",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17dee-d49b-7029-8def-b5b30aaebfd3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a17dee-d49b-7029-8def-b5b30aaebfd3",
        "storage_key": "property/6737460151189743/01a17dee-d49b-7029-8def-b5b30aaebfd3.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "#S548 Mille Lacs",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=wDLZ4sDtLBA"
    },
    {
      "id": "custom_504fea09-a84a-41ff-b32d-d3a769f03591",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17dee-e76f-704c-b91b-9aba66aad278.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a17dee-e76f-704c-b91b-9aba66aad278",
        "storage_key": "property/6737460151189743/01a17dee-e76f-704c-b91b-9aba66aad278.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "#S535 Big Sandy",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=K13Xk55D1v7"
    },
    {
      "id": "custom_39443db7-53cd-43ef-b0eb-271e39587eba",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17dee-e717-77ed-a9a5-3246c568840f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a17dee-e717-77ed-a9a5-3246c568840f",
        "storage_key": "property/6737460151189743/01a17dee-e717-77ed-a9a5-3246c568840f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "#S533 White Bear",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=PaSyJjkoh9b"
    },
    {
      "id": "custom_2f9728d6-dabe-4cb3-a6b8-d7b15865d5ef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17dee-f9c4-74f8-bc81-7b038294a0f8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a17dee-f9c4-74f8-bc81-7b038294a0f8",
        "storage_key": "property/6737460151189743/01a17dee-f9c4-74f8-bc81-7b038294a0f8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "#S147 Andrusia",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kXHdkPGAxsN"
    },
    {
      "id": "custom_04019d6a-b7e2-48a7-b59c-73e027754adf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/01a17dee-fc93-74cf-9c2a-001ce3dcf216.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a17dee-fc93-74cf-9c2a-001ce3dcf216",
        "storage_key": "property/6737460151189743/01a17dee-fc93-74cf-9c2a-001ce3dcf216.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "#S519 Minnetonka",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=DKhNeWoL4Hx"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_bcdd515d2e6212ee69ec0768",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "a1a97f57ece10c49",
      "name": "NSF Tenant Fee",
      "description": "NSF Tenant Fee",
      "amount": 30,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "nsff",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_eb31f6f8994489ae33ebb24a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "dc8adfadb0a1aaf6",
      "name": "Late Fee",
      "description": "Late Fee",
      "amount": 8,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "late",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_edaa3c29fe2eaff4e6a5c59a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "cea07e4fca0e1bff",
      "name": "Lease Termination Fee",
      "description": "Lease Termination Fee",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per Lease",
      "category": "Term",
      "charge_code": "term",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e9b9816cc0452c4e6cd21e67",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "3faabaa67cff1d97",
      "name": "Transfer Fee",
      "description": "Transfer Fee",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Transfer",
      "charge_code": "tran",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_561d1a0e3ac71233e4e593c0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "da0f3184cbbf9893",
      "name": "Water Charge",
      "description": "Water Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage based, paid monthly",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubwater",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_96dd8c6e87b3c2a841f8fe39",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "135bd527c15aa0ce",
      "name": "Sewer Charge",
      "description": "Sewer Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage based, paid monthly",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubsewer",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4bb2e7de8c0ec6cf5ca99911",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "ec8a7d9e0f8ff30d",
      "name": "Electric Charge",
      "description": "Electric Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage based, paid monthly",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "elec",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_74fb5957db8526ca15807ef6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "8ec1c4fb2a86979c",
      "name": "Utility Billing Admin Fee",
      "description": "Utility Billing Admin Fee",
      "amount": 8,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubadmin",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d66f03ffe156687126ff43a0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "18d6b18141264533",
      "name": "Trash Charge",
      "description": "Trash Utility Charge – Based on Square Footage and Occupancy",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally distributed",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubtrash",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a49a18ac7f4a83f02ee80c70",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "29d0baf9b2589256",
      "name": "Pet Screening Fee",
      "description": "Pet Screening Fee - $30 for Card Payments, $25 for ACH Payments. No cost for verified Service Animals.",
      "amount": 25,
      "amount_max": 30,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Move-In",
      "category": "Pet",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [
    {
      "id": "ec_591a48bcc0acf240ce2a3c3d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "2465728",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 300,
      "fee": 300,
      "monthly_rent": 40,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_6d26fdccde1936008dc9cd3e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "yardi",
      "external_id": "2465727",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 300,
      "fee": 300,
      "monthly_rent": 40,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-9c9a-72bf-8a92-8d29e492e67a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "daymark-uptown",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743"
    },
    {
      "lead_collector_id": "0198aa47-9cfd-7009-9c92-1dd85cf7f75a",
      "lead_source": "FACEBOOK_ADS",
      "name": "daymark-uptown",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743"
    },
    {
      "lead_collector_id": "0198aa47-9d60-74a9-bf62-1e1ab9c1f679",
      "lead_source": "LANDING_PAGE",
      "name": "daymark-uptown",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-uptown-mpls",
      "search_query": "pet friendly apartments Uptown Minneapolis",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Uptown Minneapolis",
      "h2_subtitle": "Looking for pet-friendly apartments? Daymark Uptown in Minneapolis offers ideal living spaces for you and your furry companions.",
      "page_copy": "Welcome to Daymark Uptown, where pet-friendly apartments meet comfort and convenience in Uptown Minneapolis. Our community understands that pets are family, so we provide amenities like a serene dog park for your furry friend to enjoy and roam freely. Choose from our stylish studio, one, and two-bedroom floor plans, complete with ample walk-in closets and a cozy lounge area.\n\nAt Daymark Uptown, we strive to create a welcoming environment for both you and your pets. Located in the vibrant Uptown Minneapolis neighborhood, our apartments offer easy access to numerous dog-friendly parks and trails. Additionally, our planned social activities and events present the perfect opportunity to mingle with fellow pet lovers. Experience the best in pet-friendly living at Daymark Uptown. Schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-3316-749c-aed8-761d068fa0c1.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, and a large island.",
        "public_id": "019d01a6-3316-749c-aed8-761d068fa0c1",
        "storage_key": "property/6737460151189743/019d01a6-3316-749c-aed8-761d068fa0c1.webp",
        "width": 1025,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments Uptown Minneapolis",
      "seo_description": "Discover pet-friendly living at Daymark Uptown, featuring a serene dog park and an ideal Uptown Minneapolis location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "page_item_url": "luxury-apartments-with-pool-minneapolis",
      "search_query": "luxury apartments with pool in Minneapolis",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Minneapolis",
      "h2_subtitle": "Find luxury apartments with a pool at Daymark Uptown. Experience upscale living in Minneapolis with premium amenities and stylish floor plans.",
      "page_copy": "Experience the pinnacle of luxury living at Daymark Uptown, where upscale apartments with a pool in Minneapolis are designed to exceed expectations. Our impressive community features a refreshing pool perfect for relaxation or social gatherings. Choose from our elegant studio, one, and two-bedroom floor plans, each thoughtfully designed to provide comfort and style.\n\nBeyond the pool, Daymark Uptown offers residents access to an array of premium amenities, including a state-of-the-art fitness center and sophisticated lounge. Our vibrant community in the heart of Minneapolis ensures that you're always close to the best dining, shopping, and entertainment options the city has to offer. Dive into luxury living today and discover the exceptional lifestyle awaiting you at Daymark Uptown.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-3316-749c-aed8-761d068fa0c1.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, and a large island.",
        "public_id": "019d01a6-3316-749c-aed8-761d068fa0c1",
        "storage_key": "property/6737460151189743/019d01a6-3316-749c-aed8-761d068fa0c1.webp",
        "width": 1025,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Minneapolis",
      "seo_description": "Discover luxury living at Daymark Uptown in Minneapolis. Enjoy your dream apartment featuring a pool and top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "page_item_url": "dog-park-apartments-uptown-mpls",
      "search_query": "dog park apartments in Uptown Minneapolis",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Uptown Minneapolis",
      "h2_subtitle": "Explore Daymark Uptown's pet-friendly community with a dedicated dog park, offering the ideal home for you and your pet in Uptown Minneapolis.",
      "page_copy": "At Daymark Uptown, we proudly offer dog park apartments in Uptown Minneapolis, perfect for pet owners seeking a comfortable and welcoming community. With a dedicated on-site dog park, your furry companions can enjoy off-leash play and socialization. Choose from our stylish studio, one, or two-bedroom apartments, all designed with pet-friendly features.\n\nOur Uptown Minneapolis location is ideal for pet lovers, surrounded by dog-friendly trails and parks, making it easy to explore the neighborhood with your pet. In addition to the dog park, Daymark Uptown features amenities like a fitness center and community lounge, enhancing your lifestyle. Embrace the vibrant energy of Uptown Minneapolis and discover an exceptional place for both you and your pet at Daymark Uptown.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-3316-749c-aed8-761d068fa0c1.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, and a large island.",
        "public_id": "019d01a6-3316-749c-aed8-761d068fa0c1",
        "storage_key": "property/6737460151189743/019d01a6-3316-749c-aed8-761d068fa0c1.webp",
        "width": 1025,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Uptown Minneapolis",
      "seo_description": "Live at Daymark Uptown, where pet-friendly apartments with a dog park welcome you and your furry friend in Uptown Minneapolis.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "page_item_url": "balcony-apartments-minneapolis-mn",
      "search_query": "balcony apartments Minneapolis MN",
      "category": "Amenity",
      "h1_title": "Balcony Apartments in Minneapolis, MN",
      "h2_subtitle": "Experience stunning balcony views at Daymark Uptown. Our Minneapolis apartments offer luxurious living with private balconies in select units.",
      "page_copy": "Daymark Uptown offers balcony apartments in Minneapolis, MN, where modern living meets comfort and style. Enjoy the luxury of a private balcony in select units, providing the perfect spot to unwind and admire the scenic Minneapolis views. Our thoughtfully designed studio, one, and two-bedroom apartments deliver the ultimate metropolitan living experience.\n\nLocated in the vibrant Uptown neighborhood, Daymark Uptown places you steps away from the city's best dining and entertainment options. Our community's rich amenities, including a sparkling pool and cutting-edge fitness center, complement the tranquility and relaxation of having a private balcony. Discover the ideal home at Daymark Uptown and elevate your lifestyle with our exceptional balcony apartments in Minneapolis.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-3316-749c-aed8-761d068fa0c1.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, and a large island.",
        "public_id": "019d01a6-3316-749c-aed8-761d068fa0c1",
        "storage_key": "property/6737460151189743/019d01a6-3316-749c-aed8-761d068fa0c1.webp",
        "width": 1025,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Balcony Apartments in Minneapolis, MN",
      "seo_description": "Discover Daymark Uptown's balcony apartments in Minneapolis. Enjoy luxury living with private balconies and top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "page_item_url": "studio-apartments-uptown-minneapolis",
      "search_query": "studio apartments Uptown Minneapolis",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Uptown Minneapolis",
      "h2_subtitle": "Explore stylish studio living at Daymark Uptown. Our Uptown Minneapolis location offers modern amenities and vibrant neighborhood charm.",
      "page_copy": "Daymark Uptown offers exceptional studio apartments in the heart of Uptown Minneapolis, crafted for those who value modern design and dynamic living. Our studio units are thoughtfully designed to maximize space and comfort, providing a chic backdrop for your personal style. With walk-in closets and elegant finishes, these studios are the perfect place to call home.\n\nLocated in the energetic Uptown district, our community grants residents easy access to a bustling culinary scene, eclectic shops, and lively entertainment options. In addition to the stylish interiors, Daymark Uptown enhances your living experience with amenities such as a state-of-the-art fitness center and social lounges. Discover the convenience and luxury of studio living at Daymark Uptown today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-3316-749c-aed8-761d068fa0c1.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, and a large island.",
        "public_id": "019d01a6-3316-749c-aed8-761d068fa0c1",
        "storage_key": "property/6737460151189743/019d01a6-3316-749c-aed8-761d068fa0c1.webp",
        "width": 1025,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Uptown Minneapolis",
      "seo_description": "Find your perfect studio apartment at Daymark Uptown. Enjoy modern living with great amenities in vibrant Uptown Minneapolis.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-minneapolis-mn",
      "search_query": "1 bedroom apartments Minneapolis MN",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Minneapolis, MN",
      "h2_subtitle": "Discover upscale one-bedroom living at Daymark Uptown. These Minneapolis apartments offer comfort and style in a prime location.",
      "page_copy": "Discover the perfect 1 bedroom apartments in Minneapolis, MN at Daymark Uptown, where luxury meets comfort in a vibrant urban setting. Our one-bedroom units are designed with spacious layouts and modern finishes, providing an ideal retreat for relaxation and rejuvenation. Enjoy features like walk-in closets and premium appliances that enhance your living experience.\n\nSituated in the lively Uptown neighborhood, Daymark Uptown connects you to the city's dynamic culture, with easy access to trendy eateries, shopping, and entertainment. Plus, with premium amenities such as a fitness center and planned social activities, our community is tailored to fit your lifestyle. Experience premier living in Minneapolis with the refined one-bedroom apartments at Daymark Uptown.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-3316-749c-aed8-761d068fa0c1.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, and a large island.",
        "public_id": "019d01a6-3316-749c-aed8-761d068fa0c1",
        "storage_key": "property/6737460151189743/019d01a6-3316-749c-aed8-761d068fa0c1.webp",
        "width": 1025,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Minneapolis, MN",
      "seo_description": "Experience luxurious living at Daymark Uptown's 1 bedroom apartments in Minneapolis, offering modern design and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151189743",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-55408",
      "search_query": "2 bedroom apartments 55408",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in 55408",
      "h2_subtitle": "Discover spacious two-bedroom living at Daymark Uptown, nestled in the vibrant 55408 area. Experience top-tier amenities and a lively neighborhood.",
      "page_copy": "Explore the exquisite 2 bedroom apartments available at Daymark Uptown, located in the heart of Minneapolis's vibrant 55408 ZIP code. Our spacious two-bedroom floor plans offer the perfect blend of style and functionality, featuring modern finishes and generous walk-in closets. These thoughtfully designed spaces provide an inviting atmosphere for relaxing or entertaining.\n\nLocated in the bustling Uptown neighborhood, Daymark Uptown grants you immediate access to Minneapolis's premier dining, shopping, and entertainment options. Our community enhances your living experience with exceptional amenities like a serene dog park and a contemporary fitness center. Discover the best of apartment living in the 55408 area by choosing a two-bedroom apartment at Daymark Uptown.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151189743/019d01a6-3316-749c-aed8-761d068fa0c1.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, and a large island.",
        "public_id": "019d01a6-3316-749c-aed8-761d068fa0c1",
        "storage_key": "property/6737460151189743/019d01a6-3316-749c-aed8-761d068fa0c1.webp",
        "width": 1025,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in 55408",
      "seo_description": "Find stylish 2 bedroom apartments at Daymark Uptown in the 55408 area, with modern amenities and vibrant neighborhood surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "1130"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "461741136"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6513938939"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T8HNQ56T"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 7"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "ffcfed3d-44b8-42a8-ba70-5cf6817f1d2f"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Weidner Classic"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/6d18daeb-be0e-4291-b6e4-819aa5e5d7d2/app.js?property=6d18daeb-be0e-4291-b6e4-819aa5e5d7d2&amp;propertyName=Daymark+Uptown&amp;channelUuid=c248e6ab-8dac-11ec-afb4-42010aa8d42b\" defer=\"\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "3120498942"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://wordpress-304049-2117482.cloudwaysapps.com/interactive-leasing-new/"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjRpbW5ZMkRoMitRaUNqcWFCbE1mN2c9PSIsInZhbHVlIjoiKzBKN29wanlUbXNwTTNCK3pJSTB2dz09IiwibWFjIjoiMmMzNWEwYWUzMWNkYjM1NTk0NWNlNGE2ZGE0NjU0ODljNjRkODczYzczODA5NmRmOWNlMjU4OTg2NTU3MmQwMCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "1130",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "461741136",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6513938939",
  "custom_google_gtm_id": "GTM-T8HNQ56T",
  "custom_rollout_phase": "Phase 7",
  "custom_rentgrata_token": "ffcfed3d-44b8-42a8-ba70-5cf6817f1d2f",
  "custom_vibesites_theme": "Weidner Classic",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/6d18daeb-be0e-4291-b6e4-819aa5e5d7d2/app.js?property=6d18daeb-be0e-4291-b6e4-819aa5e5d7d2&amp;propertyName=Daymark+Uptown&amp;channelUuid=c248e6ab-8dac-11ec-afb4-42010aa8d42b\" defer=\"\"></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "3120498942",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://wordpress-304049-2117482.cloudwaysapps.com/interactive-leasing-new/",
  "custom_website_subscription": "custom",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjRpbW5ZMkRoMitRaUNqcWFCbE1mN2c9PSIsInZhbHVlIjoiKzBKN29wanlUbXNwTTNCK3pJSTB2dz09IiwibWFjIjoiMmMzNWEwYWUzMWNkYjM1NTk0NWNlNGE2ZGE0NjU0ODljNjRkODczYzczODA5NmRmOWNlMjU4OTg2NTU3MmQwMCJ9"
};

export const generatedAt = '2026-11-02T22:31:17.782Z';
